export const monacoThemes = {
	"One Dark Pro": {
		inherit: true,
		base: "vs-dark",
		colors: {
			"activityBar.background": "#282c34",
			"activityBar.foreground": "#d7dae0",
			"activityBarBadge.background": "#4d78cc",
			"activityBarBadge.foreground": "#f8fafd",
			"badge.background": "#282c34",
			"button.background": "#404754",
			"button.secondaryBackground": "#30333d",
			"button.secondaryForeground": "#c0bdbd",
			"checkbox.border": "#404754",
			"debugToolBar.background": "#21252b",
			descriptionForeground: "#abb2bf",
			"diffEditor.insertedTextBackground": "#00809b33",
			"dropdown.background": "#21252b",
			"dropdown.border": "#21252b",
			"editor.background": "#282c34",
			"editor.findMatchBackground": "#d19a6644",
			"editor.findMatchBorder": "#ffffff5a",
			"editor.findMatchHighlightBackground": "#ffffff22",
			"editor.foreground": "#abb2bf",
			"editorBracketHighlight.foreground1": "#d19a66",
			"editorBracketHighlight.foreground2": "#c678dd",
			"editorBracketHighlight.foreground3": "#56b6c2",
			"editorHoverWidget.highlightForeground": "#61afef",
			"editorInlayHint.foreground": "#abb2bf",
			"editorInlayHint.background": "#2c313c",
			"editor.lineHighlightBackground": "#2c313c",
			"editorLineNumber.activeForeground": "#abb2bf",
			"editorGutter.addedBackground": "#109868",
			"editorGutter.deletedBackground": "#9A353D",
			"editorGutter.modifiedBackground": "#948B60",
			"editorOverviewRuler.addedBackground": "#109868",
			"editorOverviewRuler.deletedBackground": "#9A353D",
			"editorOverviewRuler.modifiedBackground": "#948B60",
			"editor.selectionBackground": "#67769660",
			"editor.selectionHighlightBackground": "#ffffff10",
			"editor.selectionHighlightBorder": "#dddddd",
			"editor.wordHighlightBackground": "#d2e0ff2f",
			"editor.wordHighlightBorder": "#7f848e",
			"editor.wordHighlightStrongBackground": "#abb2bf26",
			"editor.wordHighlightStrongBorder": "#7f848e",
			"editorBracketMatch.background": "#515a6b",
			"editorBracketMatch.border": "#515a6b",
			"editorCursor.background": "#ffffffc9",
			"editorCursor.foreground": "#528bff",
			"editorError.foreground": "#c24038",
			"editorGroup.background": "#181a1f",
			"editorGroup.border": "#181a1f",
			"editorGroupHeader.tabsBackground": "#21252b",
			"editorHoverWidget.background": "#21252b",
			"editorHoverWidget.border": "#181a1f",
			"editorIndentGuide.activeBackground": "#c8c8c859",
			"editorIndentGuide.background": "#3b4048",
			"editorLineNumber.foreground": "#495162",
			"editorMarkerNavigation.background": "#21252b",
			"editorRuler.foreground": "#abb2bf26",
			"editorSuggestWidget.background": "#21252b",
			"editorSuggestWidget.border": "#181a1f",
			"editorSuggestWidget.selectedBackground": "#2c313a",
			"editorWarning.foreground": "#d19a66",
			"editorWhitespace.foreground": "#ffffff1d",
			"editorWidget.background": "#21252b",
			focusBorder: "#3e4452",
			"gitDecoration.ignoredResourceForeground": "#636b78",
			"input.background": "#1d1f23",
			"input.foreground": "#abb2bf",
			"list.activeSelectionBackground": "#2c313a",
			"list.activeSelectionForeground": "#d7dae0",
			"list.focusBackground": "#323842",
			"list.focusForeground": "#f0f0f0",
			"list.highlightForeground": "#ecebeb",
			"list.hoverBackground": "#2c313a",
			"list.hoverForeground": "#abb2bf",
			"list.inactiveSelectionBackground": "#323842",
			"list.inactiveSelectionForeground": "#d7dae0",
			"list.warningForeground": "#d19a66",
			"menu.foreground": "#abb2bf",
			"menu.separatorBackground": "#343a45",
			"minimapGutter.addedBackground": "#109868",
			"minimapGutter.deletedBackground": "#9A353D",
			"minimapGutter.modifiedBackground": "#948B60",
			"panel.border": "#3e4452",
			"panelSectionHeader.background": "#21252b",
			"peekViewEditor.background": "#1b1d23",
			"peekViewEditor.matchHighlightBackground": "#29244b",
			"peekViewResult.background": "#22262b",
			"scrollbar.shadow": "#23252c",
			"scrollbarSlider.activeBackground": "#747d9180",
			"scrollbarSlider.background": "#4e566660",
			"scrollbarSlider.hoverBackground": "#5a637580",
			"settings.focusedRowBackground": "#282c34",
			"settings.headerForeground": "#fff",
			"sideBar.background": "#21252b",
			"sideBar.foreground": "#abb2bf",
			"sideBarSectionHeader.background": "#282c34",
			"sideBarSectionHeader.foreground": "#abb2bf",
			"statusBar.background": "#21252b",
			"statusBar.debuggingBackground": "#cc6633",
			"statusBar.debuggingBorder": "#ff000000",
			"statusBar.debuggingForeground": "#ffffff",
			"statusBar.foreground": "#9da5b4",
			"statusBar.noFolderBackground": "#21252b",
			"statusBarItem.remoteBackground": "#4d78cc",
			"statusBarItem.remoteForeground": "#f8fafd",
			"tab.activeBackground": "#282c34",
			"tab.activeBorder": "#b4b4b4",
			"tab.activeForeground": "#dcdcdc",
			"tab.border": "#181a1f",
			"tab.hoverBackground": "#323842",
			"tab.inactiveBackground": "#21252b",
			"tab.unfocusedHoverBackground": "#323842",
			"terminal.ansiBlack": "#3f4451",
			"terminal.ansiBlue": "#4aa5f0",
			"terminal.ansiBrightBlack": "#4f5666",
			"terminal.ansiBrightBlue": "#4dc4ff",
			"terminal.ansiBrightCyan": "#4cd1e0",
			"terminal.ansiBrightGreen": "#a5e075",
			"terminal.ansiBrightMagenta": "#de73ff",
			"terminal.ansiBrightRed": "#ff616e",
			"terminal.ansiBrightWhite": "#e6e6e6",
			"terminal.ansiBrightYellow": "#f0a45d",
			"terminal.ansiCyan": "#42b3c2",
			"terminal.ansiGreen": "#8cc265",
			"terminal.ansiMagenta": "#c162de",
			"terminal.ansiRed": "#e05561",
			"terminal.ansiWhite": "#d7dae0",
			"terminal.ansiYellow": "#d18f52",
			"terminal.background": "#282c34",
			"terminal.border": "#3e4452",
			"terminal.foreground": "#abb2bf",
			"terminal.selectionBackground": "#abb2bf30",
			"textBlockQuote.background": "#2e3440",
			"textBlockQuote.border": "#4b5362",
			"textLink.foreground": "#61afef",
			"textPreformat.foreground": "#d19a66",
			"titleBar.activeBackground": "#282c34",
			"titleBar.activeForeground": "#9da5b4",
			"titleBar.inactiveBackground": "#282c34",
			"titleBar.inactiveForeground": "#6b717d",
			"tree.indentGuidesStroke": "#ffffff1d",
			"walkThrough.embeddedEditorBackground": "#2e3440",
			"welcomePage.buttonHoverBackground": "#404754",
		},
		rules: [
			{
				foreground: "#abb2bf",
				token: "meta.embedded",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.delayed.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.list.begin.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.list.end.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.ability.begin.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.ability.end.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.operator.assignment.as.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.separator.pipe.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.separator.delimiter.unison",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.hash.unison",
			},
			{
				foreground: "#c678dd",
				token: "variable.other.generic-type.haskell",
			},
			{
				foreground: "#d19a66",
				token: "storage.type.haskell",
			},
			{
				foreground: "#e06c75",
				token: "support.variable.magic.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.period.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.element.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.parenthesis.begin.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.parenthesis.end.python",
			},
			{
				foreground: "#e5c07b",
				token: "variable.parameter.function.language.special.self.python",
			},
			{
				foreground: "#e5c07b",
				token: "variable.parameter.function.language.special.cls.python",
			},
			{
				foreground: "#abb2bf",
				token: "storage.modifier.lifetime.rust",
			},
			{
				foreground: "#61afef",
				token: "support.function.std.rust",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.lifetime.rust",
			},
			{
				foreground: "#e06c75",
				token: "variable.language.rust",
			},
			{
				foreground: "#c678dd",
				token: "support.constant.edge",
			},
			{
				foreground: "#e06c75",
				token: "constant.other.character-class.regexp",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.word",
			},
			{
				foreground: "#d19a66",
				token: "keyword.operator.quantifier.regexp",
			},
			{
				foreground: "#abb2bf",
				token: "variable.parameter.function",
			},
			{
				foreground: "#5c6370",
				token: "comment markup.link",
			},
			{
				foreground: "#e5c07b",
				token: "markup.changed.diff",
			},
			{
				foreground: "#61afef",
				token: "meta.diff.header.from-file",
			},
			{
				foreground: "#61afef",
				token: "meta.diff.header.to-file",
			},
			{
				foreground: "#61afef",
				token: "punctuation.definition.from-file.diff",
			},
			{
				foreground: "#61afef",
				token: "punctuation.definition.to-file.diff",
			},
			{
				foreground: "#98c379",
				token: "markup.inserted.diff",
			},
			{
				foreground: "#e06c75",
				token: "markup.deleted.diff",
			},
			{
				foreground: "#e06c75",
				token: "meta.function.c",
			},
			{
				foreground: "#e06c75",
				token: "meta.function.cpp",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.block.begin.bracket.curly.cpp",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.block.end.bracket.curly.cpp",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.terminator.statement.c",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.block.begin.bracket.curly.c",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.block.end.bracket.curly.c",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.parens.begin.bracket.round.c",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.parens.end.bracket.round.c",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.parameters.begin.bracket.round.c",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.parameters.end.bracket.round.c",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.key-value",
			},
			{
				foreground: "#61afef",
				token: "keyword.operator.expression.import",
			},
			{
				foreground: "#e5c07b",
				token: "support.constant.math",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.property.math",
			},
			{
				foreground: "#e5c07b",
				token: "variable.other.constant",
			},
			{
				foreground: "#e5c07b",
				token: "storage.type.annotation.java",
			},
			{
				foreground: "#e5c07b",
				token: "storage.type.object.array.java",
			},
			{
				foreground: "#e06c75",
				token: "source.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.block.begin.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.block.end.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.method-parameters.begin.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.method-parameters.end.java",
			},
			{
				foreground: "#abb2bf",
				token: "meta.method.identifier.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.method.begin.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.method.end.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.terminator.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.class.begin.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.class.end.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.inner-class.begin.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.inner-class.end.java",
			},
			{
				foreground: "#abb2bf",
				token: "meta.method-call.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.class.begin.bracket.curly.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.class.end.bracket.curly.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.method.begin.bracket.curly.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.method.end.bracket.curly.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.period.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.bracket.angle.java",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.annotation.java",
			},
			{
				foreground: "#abb2bf",
				token: "meta.method.body.java",
			},
			{
				foreground: "#61afef",
				token: "meta.method.java",
			},
			{
				foreground: "#e5c07b",
				token: "storage.modifier.import.java",
			},
			{
				foreground: "#e5c07b",
				token: "storage.type.java",
			},
			{
				foreground: "#e5c07b",
				token: "storage.type.generic.java",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.instanceof.java",
			},
			{
				foreground: "#e06c75",
				token: "meta.definition.variable.name.java",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.logical",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.bitwise",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.channel",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.property-value.scss",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.property-value.css",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.css",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.scss",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.less",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.color.w3c-standard-color-name.css",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.color.w3c-standard-color-name.scss",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.list.comma.css",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.color.w3c-standard-color-name.css",
			},
			{
				foreground: "#56b6c2",
				token: "support.type.vendored.property-name.css",
			},
			{
				foreground: "#e5c07b",
				token: "support.module.node",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.object.module",
			},
			{
				foreground: "#e5c07b",
				token: "support.module.node",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.type.module",
			},
			{
				foreground: "#e06c75",
				token: "variable.other.readwrite",
			},
			{
				foreground: "#e06c75",
				token: "meta.object-literal.key",
			},
			{
				foreground: "#e06c75",
				token: "support.variable.property",
			},
			{
				foreground: "#e06c75",
				token: "support.variable.object.process",
			},
			{
				foreground: "#e06c75",
				token: "support.variable.object.node",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.json",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.instanceof",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.new",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.ternary",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.optional",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.keyof",
			},
			{
				foreground: "#e06c75",
				token: "support.type.object.console",
			},
			{
				foreground: "#d19a66",
				token: "support.variable.property.process",
			},
			{
				foreground: "#61afef",
				token: "entity.name.function",
			},
			{
				foreground: "#61afef",
				token: "support.function.console",
			},
			{
				foreground: "#abb2bf",
				token: "keyword.operator.misc.rust",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.sigil.rust",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.delete",
			},
			{
				foreground: "#56b6c2",
				token: "support.type.object.dom",
			},
			{
				foreground: "#e06c75",
				token: "support.variable.dom",
			},
			{
				foreground: "#e06c75",
				token: "support.variable.property.dom",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.arithmetic",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.comparison",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.decrement",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.increment",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.relational",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.assignment.c",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.comparison.c",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.c",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.increment.c",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.decrement.c",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.bitwise.shift.c",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.assignment.cpp",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.comparison.cpp",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.cpp",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.increment.cpp",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.decrement.cpp",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.bitwise.shift.cpp",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.delimiter",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.separator.c",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.separator.cpp",
			},
			{
				foreground: "#56b6c2",
				token: "support.type.posix-reserved.c",
			},
			{
				foreground: "#56b6c2",
				token: "support.type.posix-reserved.cpp",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.sizeof.c",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.sizeof.cpp",
			},
			{
				foreground: "#d19a66",
				token: "variable.parameter.function.language.python",
			},
			{
				foreground: "#56b6c2",
				token: "support.type.python",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.logical.python",
			},
			{
				foreground: "#d19a66",
				token: "variable.parameter.function.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.arguments.begin.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.arguments.end.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.arguments.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.list.begin.python",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.list.end.python",
			},
			{
				foreground: "#61afef",
				token: "meta.function-call.generic.python",
			},
			{
				foreground: "#d19a66",
				token: "constant.character.format.placeholder.other.python",
			},
			{
				foreground: "#abb2bf",
				token: "keyword.operator",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.assignment.compound",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.assignment.compound.js",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.assignment.compound.ts",
			},
			{
				foreground: "#c678dd",
				token: "keyword",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.namespace",
			},
			{
				foreground: "#e06c75",
				token: "variable",
			},
			{
				foreground: "#abb2bf",
				token: "variable.c",
			},
			{
				foreground: "#e5c07b",
				token: "variable.language",
			},
			{
				foreground: "#abb2bf",
				token: "token.variable.parameter.java",
			},
			{
				foreground: "#e5c07b",
				token: "import.storage.java",
			},
			{
				foreground: "#c678dd",
				token: "token.package.keyword",
			},
			{
				foreground: "#abb2bf",
				token: "token.package",
			},
			{
				foreground: "#61afef",
				token: "entity.name.function",
			},
			{
				foreground: "#61afef",
				token: "meta.require",
			},
			{
				foreground: "#61afef",
				token: "support.function.any-method",
			},
			{
				foreground: "#61afef",
				token: "variable.function",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.type.namespace",
			},
			{
				foreground: "#e5c07b",
				token: "support.class",
			},
			{
				foreground: "#e5c07b",
				token: " entity.name.type.class",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.class.identifier.namespace.type",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.class",
			},
			{
				foreground: "#e5c07b",
				token: "variable.other.class.js",
			},
			{
				foreground: "#e5c07b",
				token: "variable.other.class.ts",
			},
			{
				foreground: "#e06c75",
				token: "variable.other.class.php",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.type",
			},
			{
				foreground: "#c678dd",
				token: "keyword.control",
			},
			{
				foreground: "#d19a66",
				token: "control.elements",
			},
			{
				foreground: "#d19a66",
				token: " keyword.operator.less",
			},
			{
				foreground: "#61afef",
				token: "keyword.other.special-method",
			},
			{
				foreground: "#c678dd",
				token: "storage",
			},
			{
				foreground: "#c678dd",
				token: "token.storage",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.delete",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.in",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.of",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.instanceof",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.new",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.typeof",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.void",
			},
			{
				foreground: "#e5c07b",
				token: "token.storage.type.java",
			},
			{
				foreground: "#56b6c2",
				token: "support.function",
			},
			{
				foreground: "#abb2bf",
				token: "support.type.property-name",
			},
			{
				foreground: "#e06c75",
				token: "support.type.property-name.toml",
			},
			{
				foreground: "#e06c75",
				token: " support.type.property-name.table.toml",
			},
			{
				foreground: "#e06c75",
				token: " support.type.property-name.array.toml",
			},
			{
				foreground: "#abb2bf",
				token: "support.constant.property-value",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.font-name",
			},
			{
				foreground: "#abb2bf",
				token: "meta.tag",
			},
			{
				foreground: "#98c379",
				token: "string",
			},
			{
				foreground: "#56b6c2",
				token: "constant.other.symbol",
			},
			{
				foreground: "#d19a66",
				token: "constant.numeric",
			},
			{
				foreground: "#d19a66",
				token: "constant",
			},
			{
				foreground: "#d19a66",
				token: "punctuation.definition.constant",
			},
			{
				foreground: "#e06c75",
				token: "entity.name.tag",
			},
			{
				foreground: "#d19a66",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "#61afef",
				token: "entity.other.attribute-name.id",
			},
			{
				foreground: "#d19a66",
				token: "entity.other.attribute-name.class.css",
			},
			{
				foreground: "#c678dd",
				token: "meta.selector",
			},
			{
				foreground: "#e06c75",
				token: "markup.heading",
			},
			{
				foreground: "#61afef",
				token: "markup.heading punctuation.definition.heading",
			},
			{
				foreground: "#61afef",
				token: " entity.name.section",
			},
			{
				foreground: "#e06c75",
				token: "keyword.other.unit",
			},
			{
				foreground: "#d19a66",
				token: "markup.bold",
			},
			{
				foreground: "#d19a66",
				token: "todo.bold",
			},
			{
				foreground: "#e5c07b",
				token: "punctuation.definition.bold",
			},
			{
				foreground: "#c678dd",
				token: "markup.italic",
			},
			{
				foreground: "#c678dd",
				token: " punctuation.definition.italic",
			},
			{
				foreground: "#c678dd",
				token: "todo.emphasis",
			},
			{
				foreground: "#c678dd",
				token: "emphasis md",
			},
			{
				foreground: "#e06c75",
				token: "entity.name.section.markdown",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.heading.markdown",
			},
			{
				foreground: "#e5c07b",
				token: "punctuation.definition.list.begin.markdown",
			},
			{
				foreground: "#abb2bf",
				token: "markup.heading.setext",
			},
			{
				foreground: "#d19a66",
				token: "punctuation.definition.bold.markdown",
			},
			{
				foreground: "#98c379",
				token: "markup.inline.raw.markdown",
			},
			{
				foreground: "#98c379",
				token: "markup.inline.raw.string.markdown",
			},
			{
				foreground: "#e5c07b",
				token: "punctuation.definition.raw.markdown",
			},
			{
				foreground: "#e5c07b",
				token: "punctuation.definition.list.markdown",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.string.begin.markdown",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.string.end.markdown",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.metadata.markdown",
			},
			{
				foreground: "#e06c75",
				token: "beginning.punctuation.definition.list.markdown",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.definition.metadata.markdown",
			},
			{
				foreground: "#c678dd",
				token: "markup.underline.link.markdown",
			},
			{
				foreground: "#c678dd",
				token: "markup.underline.link.image.markdown",
			},
			{
				foreground: "#61afef",
				token: "string.other.link.title.markdown",
			},
			{
				foreground: "#61afef",
				token: "string.other.link.description.markdown",
			},
			{
				foreground: "#98c379",
				token: "markup.raw.monospace.asciidoc",
			},
			{
				foreground: "#e5c07b",
				token: "punctuation.definition.asciidoc",
			},
			{
				foreground: "#e5c07b",
				token: "markup.list.asciidoc",
			},
			{
				foreground: "#c678dd",
				token: "markup.link.asciidoc",
			},
			{
				foreground: "#c678dd",
				token: "markup.other.url.asciidoc",
			},
			{
				foreground: "#61afef",
				token: "string.unquoted.asciidoc",
			},
			{
				foreground: "#61afef",
				token: "markup.other.url.asciidoc",
			},
			{
				foreground: "#56b6c2",
				token: "string.regexp",
			},
			{
				foreground: "#e06c75",
				token: "punctuation.section.embedded",
			},
			{
				foreground: "#e06c75",
				token: " variable.interpolation",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.section.embedded.begin",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.section.embedded.end",
			},
			{
				foreground: "#ffffff",
				token: "invalid.illegal",
			},
			{
				foreground: "#abb2bf",
				token: "invalid.illegal.bad-ampersand.html",
			},
			{
				foreground: "#e06c75",
				token: "invalid.illegal.unrecognized-tag.html",
			},
			{
				foreground: "#ffffff",
				token: "invalid.broken",
			},
			{
				foreground: "#ffffff",
				token: "invalid.deprecated",
			},
			{
				foreground: "#d19a66",
				token: "invalid.deprecated.entity.other.attribute-name.html",
			},
			{
				foreground: "#ffffff",
				token: "invalid.unimplemented",
			},
			{
				foreground: "#e06c75",
				token: "source.json meta.structure.dictionary.json > string.quoted.json",
			},
			{
				foreground: "#e06c75",
				token: "source.json meta.structure.dictionary.json > string.quoted.json > punctuation.string",
			},
			{
				foreground: "#98c379",
				token: "source.json meta.structure.dictionary.json > value.json > string.quoted.json",
			},
			{
				foreground: "#98c379",
				token: "source.json meta.structure.array.json > value.json > string.quoted.json",
			},
			{
				foreground: "#98c379",
				token: "source.json meta.structure.dictionary.json > value.json > string.quoted.json > punctuation",
			},
			{
				foreground: "#98c379",
				token: "source.json meta.structure.array.json > value.json > string.quoted.json > punctuation",
			},
			{
				foreground: "#56b6c2",
				token: "source.json meta.structure.dictionary.json > constant.language.json",
			},
			{
				foreground: "#56b6c2",
				token: "source.json meta.structure.array.json > constant.language.json",
			},
			{
				foreground: "#e06c75",
				token: "support.type.property-name.json",
			},
			{
				foreground: "#e06c75",
				token: "support.type.property-name.json punctuation",
			},
			{
				foreground: "#c678dd",
				token: "text.html.laravel-blade source.php.embedded.line.html entity.name.tag.laravel-blade",
			},
			{
				foreground: "#c678dd",
				token: "text.html.laravel-blade source.php.embedded.line.html support.constant.laravel-blade",
			},
			{
				foreground: "#e5c07b",
				token: "support.other.namespace.use.php",
			},
			{
				foreground: "#e5c07b",
				token: "support.other.namespace.use-as.php",
			},
			{
				foreground: "#e5c07b",
				token: "entity.other.alias.php",
			},
			{
				foreground: "#e5c07b",
				token: "meta.interface.php",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.error-control.php",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.type.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.array.begin.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.array.end.php",
			},
			{
				foreground: "#f44747",
				token: "invalid.illegal.non-null-typehinted.php",
			},
			{
				foreground: "#e5c07b",
				token: "storage.type.php",
			},
			{
				foreground: "#e5c07b",
				token: "meta.other.type.phpdoc.php",
			},
			{
				foreground: "#e5c07b",
				token: "keyword.other.type.php",
			},
			{
				foreground: "#e5c07b",
				token: "keyword.other.array.phpdoc.php",
			},
			{
				foreground: "#61afef",
				token: "meta.function-call.php",
			},
			{
				foreground: "#61afef",
				token: "meta.function-call.object.php",
			},
			{
				foreground: "#61afef",
				token: "meta.function-call.static.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.parameters.begin.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.parameters.end.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.delimiter.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.scope.begin.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.section.scope.end.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.terminator.expression.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.arguments.begin.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.arguments.end.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.storage-type.begin.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.storage-type.end.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.array.begin.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.array.end.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.begin.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.end.bracket.round.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.begin.bracket.curly.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.end.bracket.curly.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.section.switch-block.end.bracket.curly.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.section.switch-block.start.bracket.curly.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.section.switch-block.begin.bracket.curly.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.section.switch-block.end.bracket.curly.php",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.core.rust",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.ext.php",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.std.php",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.core.php",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.parser-token.php",
			},
			{
				foreground: "#61afef",
				token: "entity.name.goto-label.php",
			},
			{
				foreground: "#61afef",
				token: "support.other.php",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.logical.php",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.bitwise.php",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.arithmetic.php",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.regexp.php",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.comparison.php",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.heredoc.php",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.nowdoc.php",
			},
			{
				foreground: "#61afef",
				token: "meta.function.decorator.python",
			},
			{
				foreground: "#56b6c2",
				token: "support.token.decorator.python",
			},
			{
				foreground: "#56b6c2",
				token: "meta.function.decorator.identifier.python",
			},
			{
				foreground: "#abb2bf",
				token: "function.parameter",
			},
			{
				foreground: "#abb2bf",
				token: "function.brace",
			},
			{
				foreground: "#abb2bf",
				token: "function.parameter.ruby",
			},
			{
				foreground: "#abb2bf",
				token: " function.parameter.cs",
			},
			{
				foreground: "#56b6c2",
				token: "constant.language.symbol.ruby",
			},
			{
				foreground: "#56b6c2",
				token: "constant.language.symbol.hashkey.ruby",
			},
			{
				foreground: "#56b6c2",
				token: "rgb-value",
			},
			{
				foreground: "#d19a66",
				token: "inline-color-decoration rgb-value",
			},
			{
				foreground: "#d19a66",
				token: "less rgb-value",
			},
			{
				foreground: "#e06c75",
				token: "selector.sass",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.primitive.ts",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.builtin.ts",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.primitive.tsx",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.builtin.tsx",
			},
			{
				foreground: "#abb2bf",
				token: "block.scope.end",
			},
			{
				foreground: "#abb2bf",
				token: "block.scope.begin",
			},
			{
				foreground: "#e5c07b",
				token: "storage.type.cs",
			},
			{
				foreground: "#e06c75",
				token: "entity.name.variable.local.cs",
			},
			{
				foreground: "#61afef",
				token: "token.info-token",
			},
			{
				foreground: "#d19a66",
				token: "token.warn-token",
			},
			{
				foreground: "#f44747",
				token: "token.error-token",
			},
			{
				foreground: "#c678dd",
				token: "token.debug-token",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.definition.template-expression.begin",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.definition.template-expression.end",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.section.embedded",
			},
			{
				foreground: "#abb2bf",
				token: "meta.template.expression",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.module",
			},
			{
				foreground: "#61afef",
				token: "support.type.type.flowtype",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.primitive",
			},
			{
				foreground: "#e06c75",
				token: "meta.property.object",
			},
			{
				foreground: "#e06c75",
				token: "variable.parameter.function.js",
			},
			{
				foreground: "#98c379",
				token: "keyword.other.template.begin",
			},
			{
				foreground: "#98c379",
				token: "keyword.other.template.end",
			},
			{
				foreground: "#98c379",
				token: "keyword.other.substitution.begin",
			},
			{
				foreground: "#98c379",
				token: "keyword.other.substitution.end",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.operator.assignment",
			},
			{
				foreground: "#e5c07b",
				token: "keyword.operator.assignment.go",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.arithmetic.go",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.address.go",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.package.go",
			},
			{
				foreground: "#56b6c2",
				token: "support.type.prelude.elm",
			},
			{
				foreground: "#d19a66",
				token: "support.constant.elm",
			},
			{
				foreground: "#c678dd",
				token: "punctuation.quasi.element",
			},
			{
				foreground: "#e06c75",
				token: "constant.character.entity",
			},
			{
				foreground: "#56b6c2",
				token: "entity.other.attribute-name.pseudo-element",
			},
			{
				foreground: "#56b6c2",
				token: "entity.other.attribute-name.pseudo-class",
			},
			{
				foreground: "#e5c07b",
				token: "entity.global.clojure",
			},
			{
				foreground: "#e06c75",
				token: "meta.symbol.clojure",
			},
			{
				foreground: "#56b6c2",
				token: "constant.keyword.clojure",
			},
			{
				foreground: "#e06c75",
				token: "meta.arguments.coffee",
			},
			{
				foreground: "#e06c75",
				token: "variable.parameter.function.coffee",
			},
			{
				foreground: "#98c379",
				token: "source.ini",
			},
			{
				foreground: "#e06c75",
				token: "meta.scope.prerequisites.makefile",
			},
			{
				foreground: "#e5c07b",
				token: "source.makefile",
			},
			{
				foreground: "#e5c07b",
				token: "storage.modifier.import.groovy",
			},
			{
				foreground: "#61afef",
				token: "meta.method.groovy",
			},
			{
				foreground: "#e06c75",
				token: "meta.definition.variable.name.groovy",
			},
			{
				foreground: "#98c379",
				token: "meta.definition.class.inherited.classes.groovy",
			},
			{
				foreground: "#e5c07b",
				token: "support.variable.semantic.hlsl",
			},
			{
				foreground: "#c678dd",
				token: "support.type.texture.hlsl",
			},
			{
				foreground: "#c678dd",
				token: "support.type.sampler.hlsl",
			},
			{
				foreground: "#c678dd",
				token: "support.type.object.hlsl",
			},
			{
				foreground: "#c678dd",
				token: "support.type.object.rw.hlsl",
			},
			{
				foreground: "#c678dd",
				token: "support.type.fx.hlsl",
			},
			{
				foreground: "#c678dd",
				token: "support.type.object.hlsl",
			},
			{
				foreground: "#e06c75",
				token: "text.variable",
			},
			{
				foreground: "#e06c75",
				token: "text.bracketed",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.swift",
			},
			{
				foreground: "#e5c07b",
				token: "support.type.vb.asp",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.function.xi",
			},
			{
				foreground: "#56b6c2",
				token: "entity.name.class.xi",
			},
			{
				foreground: "#e06c75",
				token: "constant.character.character-class.regexp.xi",
			},
			{
				foreground: "#c678dd",
				token: "constant.regexp.xi",
			},
			{
				foreground: "#56b6c2",
				token: "keyword.control.xi",
			},
			{
				foreground: "#abb2bf",
				token: "invalid.xi",
			},
			{
				foreground: "#98c379",
				token: "beginning.punctuation.definition.quote.markdown.xi",
			},
			{
				foreground: "#7f848e",
				token: "beginning.punctuation.definition.list.markdown.xi",
			},
			{
				foreground: "#61afef",
				token: "constant.character.xi",
			},
			{
				foreground: "#61afef",
				token: "accent.xi",
			},
			{
				foreground: "#d19a66",
				token: "wikiword.xi",
			},
			{
				foreground: "#ffffff",
				token: "constant.other.color.rgb-value.xi",
			},
			{
				foreground: "#5c6370",
				token: "punctuation.definition.tag.xi",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.label.cs",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.scope-resolution.function.call",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.scope-resolution.function.definition",
			},
			{
				foreground: "#e06c75",
				token: "entity.name.label.cs",
			},
			{
				foreground: "#e06c75",
				token: "markup.heading.setext.1.markdown",
			},
			{
				foreground: "#e06c75",
				token: "markup.heading.setext.2.markdown",
			},
			{
				foreground: "#abb2bf",
				token: " meta.brace.square",
			},
			{
				foreground: "#7f848e",
				fontStyle: "italic",
				token: "comment",
			},
			{
				foreground: "#7f848e",
				fontStyle: "italic",
				token: " punctuation.definition.comment",
			},
			{
				foreground: "#5c6370",
				token: "markup.quote.markdown",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.definition.block.sequence.item.yaml",
			},
			{
				foreground: "#56b6c2",
				token: "constant.language.symbol.elixir",
			},
			{
				foreground: "#56b6c2",
				token: "constant.language.symbol.double-quoted.elixir",
			},
			{
				foreground: "#e5c07b",
				token: "entity.name.variable.parameter.cs",
			},
			{
				foreground: "#e06c75",
				token: "entity.name.variable.field.cs",
			},
			{
				foreground: "#e06c75",
				token: "markup.deleted",
			},
			{
				foreground: "#98c379",
				token: "markup.inserted",
			},
			{
				fontStyle: "underline",
				token: "markup.underline",
			},
			{
				foreground: "#BE5046",
				token: "punctuation.section.embedded.begin.php",
			},
			{
				foreground: "#BE5046",
				token: "punctuation.section.embedded.end.php",
			},
			{
				foreground: "#abb2bf",
				token: "support.other.namespace.php",
			},
			{
				foreground: "#e06c75",
				token: "variable.parameter.function.latex",
			},
			{
				foreground: "#e5c07b",
				token: "variable.other.object",
			},
			{
				foreground: "#e06c75",
				token: "variable.other.constant.property",
			},
			{
				foreground: "#e5c07b",
				token: "entity.other.inherited-class",
			},
			{
				foreground: "#e06c75",
				token: "variable.other.readwrite.c",
			},
			{
				foreground: "#abb2bf",
				token: "entity.name.variable.parameter.php",
			},
			{
				foreground: "#abb2bf",
				token: "punctuation.separator.colon.php",
			},
			{
				foreground: "#abb2bf",
				token: "constant.other.php",
			},
			{
				foreground: "#c678dd",
				token: "constant.numeric.decimal.asm.x86_64",
			},
			{
				foreground: "#d19a66",
				token: "support.other.parenthesis.regexp",
			},
			{
				foreground: "#56b6c2",
				token: "constant.character.escape",
			},
			{
				foreground: "#e06c75",
				token: "string.regexp",
			},
			{
				foreground: "#98c379",
				token: "log.info",
			},
			{
				foreground: "#e5c07b",
				token: "log.warning",
			},
			{
				foreground: "#e06c75",
				token: "log.error",
			},
			{
				foreground: "#c678dd",
				token: "keyword.operator.expression.is",
			},
			{
				foreground: "#e06c75",
				token: "entity.name.label",
			},
			{
				fontStyle: "italic",
				token: "entity.other.attribute-name.js",
			},
			{
				fontStyle: "italic",
				token: "entity.other.attribute-name.ts",
			},
			{
				fontStyle: "italic",
				token: "entity.other.attribute-name.jsx",
			},
			{
				fontStyle: "italic",
				token: "entity.other.attribute-name.tsx",
			},
			{
				fontStyle: "italic",
				token: "variable.parameter",
			},
			{
				fontStyle: "italic",
				token: "variable.language.super",
			},
			{
				fontStyle: "italic",
				token: "comment.line.double-slash",
			},
			{
				fontStyle: "italic",
				token: "comment.block.documentation",
			},
			{
				fontStyle: "italic",
				token: "markup.italic.markdown",
			},
		],
		encodedTokensColors: [],
	},
	"GitHub Dark": {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "24292e",
				token: "",
			},
			{
				foreground: "959da5",
				token: "comment",
			},
			{
				foreground: "959da5",
				token: "punctuation.definition.comment",
			},
			{
				foreground: "959da5",
				token: "string.comment",
			},
			{
				foreground: "c8e1ff",
				token: "constant",
			},
			{
				foreground: "c8e1ff",
				token: "entity.name.constant",
			},
			{
				foreground: "c8e1ff",
				token: "variable.other.constant",
			},
			{
				foreground: "c8e1ff",
				token: "variable.language",
			},
			{
				foreground: "b392f0",
				token: "entity",
			},
			{
				foreground: "b392f0",
				token: "entity.name",
			},
			{
				foreground: "f6f8fa",
				token: "variable.parameter.function",
			},
			{
				foreground: "7bcc72",
				token: "entity.name.tag",
			},
			{
				foreground: "ea4a5a",
				token: "keyword",
			},
			{
				foreground: "ea4a5a",
				token: "storage",
			},
			{
				foreground: "ea4a5a",
				token: "storage.type",
			},
			{
				foreground: "f6f8fa",
				token: "storage.modifier.package",
			},
			{
				foreground: "f6f8fa",
				token: "storage.modifier.import",
			},
			{
				foreground: "f6f8fa",
				token: "storage.type.java",
			},
			{
				foreground: "79b8ff",
				token: "string",
			},
			{
				foreground: "79b8ff",
				token: "punctuation.definition.string",
			},
			{
				foreground: "79b8ff",
				token: "string punctuation.section.embedded source",
			},
			{
				foreground: "c8e1ff",
				token: "support",
			},
			{
				foreground: "c8e1ff",
				token: "meta.property-name",
			},
			{
				foreground: "fb8532",
				token: "variable",
			},
			{
				foreground: "f6f8fa",
				token: "variable.other",
			},
			{
				foreground: "d73a49",
				fontStyle: "bold italic underline",
				token: "invalid.broken",
			},
			{
				foreground: "d73a49",
				fontStyle: "bold italic underline",
				token: "invalid.deprecated",
			},
			{
				foreground: "fafbfc",
				background: "d73a49",
				fontStyle: "italic underline",
				token: "invalid.illegal",
			},
			{
				foreground: "fafbfc",
				background: "d73a49",
				fontStyle: "italic underline",
				token: "carriage-return",
			},
			{
				foreground: "d73a49",
				fontStyle: "bold italic underline",
				token: "invalid.unimplemented",
			},
			{
				foreground: "d73a49",
				token: "message.error",
			},
			{
				foreground: "f6f8fa",
				token: "string source",
			},
			{
				foreground: "c8e1ff",
				token: "string variable",
			},
			{
				foreground: "79b8ff",
				token: "source.regexp",
			},
			{
				foreground: "79b8ff",
				token: "string.regexp",
			},
			{
				foreground: "79b8ff",
				token: "string.regexp.character-class",
			},
			{
				foreground: "79b8ff",
				token: "string.regexp constant.character.escape",
			},
			{
				foreground: "79b8ff",
				token: "string.regexp source.ruby.embedded",
			},
			{
				foreground: "79b8ff",
				token: "string.regexp string.regexp.arbitrary-repitition",
			},
			{
				foreground: "7bcc72",
				fontStyle: "bold",
				token: "string.regexp constant.character.escape",
			},
			{
				foreground: "c8e1ff",
				token: "support.constant",
			},
			{
				foreground: "c8e1ff",
				token: "support.variable",
			},
			{
				foreground: "c8e1ff",
				token: "meta.module-reference",
			},
			{
				foreground: "fb8532",
				token: "markup.list",
			},
			{
				foreground: "0366d6",
				fontStyle: "bold",
				token: "markup.heading",
			},
			{
				foreground: "0366d6",
				fontStyle: "bold",
				token: "markup.heading entity.name",
			},
			{
				foreground: "c8e1ff",
				token: "markup.quote",
			},
			{
				foreground: "f6f8fa",
				fontStyle: "italic",
				token: "markup.italic",
			},
			{
				foreground: "f6f8fa",
				fontStyle: "bold",
				token: "markup.bold",
			},
			{
				foreground: "c8e1ff",
				token: "markup.raw",
			},
			{
				foreground: "b31d28",
				background: "ffeef0",
				token: "markup.deleted",
			},
			{
				foreground: "b31d28",
				background: "ffeef0",
				token: "meta.diff.header.from-file",
			},
			{
				foreground: "b31d28",
				background: "ffeef0",
				token: "punctuation.definition.deleted",
			},
			{
				foreground: "176f2c",
				background: "f0fff4",
				token: "markup.inserted",
			},
			{
				foreground: "176f2c",
				background: "f0fff4",
				token: "meta.diff.header.to-file",
			},
			{
				foreground: "176f2c",
				background: "f0fff4",
				token: "punctuation.definition.inserted",
			},
			{
				foreground: "b08800",
				background: "fffdef",
				token: "markup.changed",
			},
			{
				foreground: "b08800",
				background: "fffdef",
				token: "punctuation.definition.changed",
			},
			{
				foreground: "2f363d",
				background: "959da5",
				token: "markup.ignored",
			},
			{
				foreground: "2f363d",
				background: "959da5",
				token: "markup.untracked",
			},
			{
				foreground: "b392f0",
				fontStyle: "bold",
				token: "meta.diff.range",
			},
			{
				foreground: "c8e1ff",
				token: "meta.diff.header",
			},
			{
				foreground: "0366d6",
				fontStyle: "bold",
				token: "meta.separator",
			},
			{
				foreground: "0366d6",
				token: "meta.output",
			},
			{
				foreground: "ffeef0",
				token: "brackethighlighter.tag",
			},
			{
				foreground: "ffeef0",
				token: "brackethighlighter.curly",
			},
			{
				foreground: "ffeef0",
				token: "brackethighlighter.round",
			},
			{
				foreground: "ffeef0",
				token: "brackethighlighter.square",
			},
			{
				foreground: "ffeef0",
				token: "brackethighlighter.angle",
			},
			{
				foreground: "ffeef0",
				token: "brackethighlighter.quote",
			},
			{
				foreground: "d73a49",
				token: "brackethighlighter.unmatched",
			},
			{
				foreground: "d73a49",
				token: "sublimelinter.mark.error",
			},
			{
				foreground: "fb8532",
				token: "sublimelinter.mark.warning",
			},
			{
				foreground: "6a737d",
				token: "sublimelinter.gutter-mark",
			},
			{
				foreground: "79b8ff",
				fontStyle: "underline",
				token: "constant.other.reference.link",
			},
			{
				foreground: "79b8ff",
				fontStyle: "underline",
				token: "string.other.link",
			},
		],
		colors: {
			"editor.foreground": "#f6f8fa",
			"editor.background": "#24292e",
			"editor.selectionBackground": "#4c2889",
			"editor.inactiveSelectionBackground": "#444d56",
			"editor.lineHighlightBackground": "#444d56",
			"editorCursor.foreground": "#ffffff",
			"editorWhitespace.foreground": "#6a737d",
			"editorIndentGuide.background": "#6a737d",
			"editorIndentGuide.activeBackground": "#f6f8fa",
			"editor.selectionHighlightBorder": "#444d56",
		},
	},
	"GitHub Light": {
		base: "vs",
		inherit: true,
		rules: [
			{
				background: "ffffff",
				token: "",
			},
			{
				foreground: "6a737d",
				token: "comment",
			},
			{
				foreground: "6a737d",
				token: "punctuation.definition.comment",
			},
			{
				foreground: "6a737d",
				token: "string.comment",
			},
			{
				foreground: "005cc5",
				token: "constant",
			},
			{
				foreground: "005cc5",
				token: "entity.name.constant",
			},
			{
				foreground: "005cc5",
				token: "variable.other.constant",
			},
			{
				foreground: "005cc5",
				token: "variable.language",
			},
			{
				foreground: "6f42c1",
				token: "entity",
			},
			{
				foreground: "6f42c1",
				token: "entity.name",
			},
			{
				foreground: "24292e",
				token: "variable.parameter.function",
			},
			{
				foreground: "22863a",
				token: "entity.name.tag",
			},
			{
				foreground: "d73a49",
				token: "keyword",
			},
			{
				foreground: "d73a49",
				token: "storage",
			},
			{
				foreground: "d73a49",
				token: "storage.type",
			},
			{
				foreground: "24292e",
				token: "storage.modifier.package",
			},
			{
				foreground: "24292e",
				token: "storage.modifier.import",
			},
			{
				foreground: "24292e",
				token: "storage.type.java",
			},
			{
				foreground: "032f62",
				token: "string",
			},
			{
				foreground: "032f62",
				token: "punctuation.definition.string",
			},
			{
				foreground: "032f62",
				token: "string punctuation.section.embedded source",
			},
			{
				foreground: "005cc5",
				token: "support",
			},
			{
				foreground: "005cc5",
				token: "meta.property-name",
			},
			{
				foreground: "e36209",
				token: "variable",
			},
			{
				foreground: "24292e",
				token: "variable.other",
			},
			{
				foreground: "b31d28",
				fontStyle: "bold italic underline",
				token: "invalid.broken",
			},
			{
				foreground: "b31d28",
				fontStyle: "bold italic underline",
				token: "invalid.deprecated",
			},
			{
				foreground: "fafbfc",
				background: "b31d28",
				fontStyle: "italic underline",
				token: "invalid.illegal",
			},
			{
				foreground: "fafbfc",
				background: "d73a49",
				fontStyle: "italic underline",
				token: "carriage-return",
			},
			{
				foreground: "b31d28",
				fontStyle: "bold italic underline",
				token: "invalid.unimplemented",
			},
			{
				foreground: "b31d28",
				token: "message.error",
			},
			{
				foreground: "24292e",
				token: "string source",
			},
			{
				foreground: "005cc5",
				token: "string variable",
			},
			{
				foreground: "032f62",
				token: "source.regexp",
			},
			{
				foreground: "032f62",
				token: "string.regexp",
			},
			{
				foreground: "032f62",
				token: "string.regexp.character-class",
			},
			{
				foreground: "032f62",
				token: "string.regexp constant.character.escape",
			},
			{
				foreground: "032f62",
				token: "string.regexp source.ruby.embedded",
			},
			{
				foreground: "032f62",
				token: "string.regexp string.regexp.arbitrary-repitition",
			},
			{
				foreground: "22863a",
				fontStyle: "bold",
				token: "string.regexp constant.character.escape",
			},
			{
				foreground: "005cc5",
				token: "support.constant",
			},
			{
				foreground: "005cc5",
				token: "support.variable",
			},
			{
				foreground: "005cc5",
				token: "meta.module-reference",
			},
			{
				foreground: "735c0f",
				token: "markup.list",
			},
			{
				foreground: "005cc5",
				fontStyle: "bold",
				token: "markup.heading",
			},
			{
				foreground: "005cc5",
				fontStyle: "bold",
				token: "markup.heading entity.name",
			},
			{
				foreground: "22863a",
				token: "markup.quote",
			},
			{
				foreground: "24292e",
				fontStyle: "italic",
				token: "markup.italic",
			},
			{
				foreground: "24292e",
				fontStyle: "bold",
				token: "markup.bold",
			},
			{
				foreground: "005cc5",
				token: "markup.raw",
			},
			{
				foreground: "b31d28",
				background: "ffeef0",
				token: "markup.deleted",
			},
			{
				foreground: "b31d28",
				background: "ffeef0",
				token: "meta.diff.header.from-file",
			},
			{
				foreground: "b31d28",
				background: "ffeef0",
				token: "punctuation.definition.deleted",
			},
			{
				foreground: "22863a",
				background: "f0fff4",
				token: "markup.inserted",
			},
			{
				foreground: "22863a",
				background: "f0fff4",
				token: "meta.diff.header.to-file",
			},
			{
				foreground: "22863a",
				background: "f0fff4",
				token: "punctuation.definition.inserted",
			},
			{
				foreground: "e36209",
				background: "ffebda",
				token: "markup.changed",
			},
			{
				foreground: "e36209",
				background: "ffebda",
				token: "punctuation.definition.changed",
			},
			{
				foreground: "f6f8fa",
				background: "005cc5",
				token: "markup.ignored",
			},
			{
				foreground: "f6f8fa",
				background: "005cc5",
				token: "markup.untracked",
			},
			{
				foreground: "6f42c1",
				fontStyle: "bold",
				token: "meta.diff.range",
			},
			{
				foreground: "005cc5",
				token: "meta.diff.header",
			},
			{
				foreground: "005cc5",
				fontStyle: "bold",
				token: "meta.separator",
			},
			{
				foreground: "005cc5",
				token: "meta.output",
			},
			{
				foreground: "586069",
				token: "brackethighlighter.tag",
			},
			{
				foreground: "586069",
				token: "brackethighlighter.curly",
			},
			{
				foreground: "586069",
				token: "brackethighlighter.round",
			},
			{
				foreground: "586069",
				token: "brackethighlighter.square",
			},
			{
				foreground: "586069",
				token: "brackethighlighter.angle",
			},
			{
				foreground: "586069",
				token: "brackethighlighter.quote",
			},
			{
				foreground: "b31d28",
				token: "brackethighlighter.unmatched",
			},
			{
				foreground: "b31d28",
				token: "sublimelinter.mark.error",
			},
			{
				foreground: "e36209",
				token: "sublimelinter.mark.warning",
			},
			{
				foreground: "959da5",
				token: "sublimelinter.gutter-mark",
			},
			{
				foreground: "032f62",
				fontStyle: "underline",
				token: "constant.other.reference.link",
			},
			{
				foreground: "032f62",
				fontStyle: "underline",
				token: "string.other.link",
			},
		],
		colors: {
			"editor.foreground": "#24292e",
			"editor.background": "#ffffff",
			"editor.selectionBackground": "#c8c8fa",
			"editor.inactiveSelectionBackground": "#fafbfc",
			"editor.lineHighlightBackground": "#fafbfc",
			"editorCursor.foreground": "#24292e",
			"editorWhitespace.foreground": "#959da5",
			"editorIndentGuide.background": "#959da5",
			"editorIndentGuide.activeBackground": "#24292e",
			"editor.selectionHighlightBorder": "#fafbfc",
		},
	},
	Katzenmilch: {
		base: "vs",
		inherit: true,
		rules: [
			{
				background: "E8E9E8",
				token: "",
			},
			{
				foreground: "949494e8",
				background: "dcdcdc8f",
				token: "comment",
			},
			{
				foreground: "a54776",
				background: "e9d6dc85",
				token: "comment.line.region",
			},
			{
				foreground: "668d68",
				background: "e9e4be",
				token: "comment.line.marker.php",
			},
			{
				foreground: "456e48",
				background: "d9eab8",
				token: "comment.line.todo.php",
			},
			{
				foreground: "880006",
				background: "e1d0ca",
				token: "comment.line.fixme.php",
			},
			{
				foreground: "cd6839",
				token: "constant",
			},
			{
				foreground: "8b4726",
				background: "e8e9e8",
				token: "entity",
			},
			{
				foreground: "a52a2a",
				token: "storage",
			},
			{
				foreground: "cd3700",
				token: "keyword.control",
			},
			{
				foreground: "b03060",
				token: "support.function - variable",
			},
			{
				foreground: "b03060",
				token: "keyword.other.special-method.ruby",
			},
			{
				foreground: "b83126",
				token: "keyword.operator.comparison",
			},
			{
				foreground: "b83126",
				token: "keyword.operator.logical",
			},
			{
				foreground: "639300",
				token: "string",
			},
			{
				foreground: "007e69",
				token: "string.quoted.double.ruby source.ruby.embedded.source",
			},
			{
				foreground: "104e8b",
				token: "support",
			},
			{
				foreground: "009acd",
				token: "variable",
			},
			{
				foreground: "fd1732",
				background: "e8e9e8",
				fontStyle: "italic underline",
				token: "invalid.deprecated",
			},
			{
				foreground: "fd1224",
				background: "ff060026",
				token: "invalid.illegal",
			},
			{
				foreground: "7b211a",
				background: "77ade900",
				token: "text source",
			},
			{
				foreground: "005273",
				fontStyle: "italic",
				token: "entity.other.inherited-class",
			},
			{
				foreground: "417e00",
				background: "c9d4be",
				token: "string.regexp",
			},
			{
				foreground: "005273",
				token: "support.function",
			},
			{
				foreground: "cf6a4c",
				token: "support.constant",
			},
			{
				fontStyle: "underline",
				token: "entity.name.type",
			},
			{
				foreground: "676767",
				fontStyle: "italic",
				token: "meta.cast",
			},
			{
				foreground: "494949",
				token: "meta.sgml.html meta.doctype",
			},
			{
				foreground: "494949",
				token: "meta.sgml.html meta.doctype entity",
			},
			{
				foreground: "494949",
				token: "meta.sgml.html meta.doctype string",
			},
			{
				foreground: "494949",
				token: "meta.xml-processing",
			},
			{
				foreground: "494949",
				token: "meta.xml-processing entity",
			},
			{
				foreground: "494949",
				token: "meta.xml-processing string",
			},
			{
				foreground: "005273",
				token: "meta.tag",
			},
			{
				foreground: "005273",
				token: "meta.tag entity",
			},
			{
				foreground: "005273",
				token: "source entity.name.tag",
			},
			{
				foreground: "005273",
				token: "source entity.other.attribute-name",
			},
			{
				foreground: "005273",
				token: "meta.tag.inline",
			},
			{
				foreground: "005273",
				token: "meta.tag.inline entity",
			},
			{
				foreground: "b85423",
				token: "entity.name.tag.namespace",
			},
			{
				foreground: "b85423",
				token: "entity.other.attribute-name.namespace",
			},
			{
				foreground: "b83126",
				token: "entity.name.tag.css",
			},
			{
				foreground: "b12e25",
				token: "meta.selector.css entity.other.attribute-name.tag.pseudo-class",
			},
			{
				foreground: "b8002d",
				token: "meta.selector.css entity.other.attribute-name.id",
			},
			{
				foreground: "b8002d",
				token: "entity.other.attribute-name.id.css",
			},
			{
				foreground: "b8012d",
				token: "meta.selector.css entity.other.attribute-name.class",
			},
			{
				foreground: "b8012d",
				token: "entity.other.attribute-name.class.css",
			},
			{
				foreground: "005273",
				token: "support.type.property-name.css",
			},
			{
				foreground: "005273",
				token: "meta.property-name",
			},
			{
				foreground: "8693a5",
				token: "meta.preprocessor.at-rule keyword.control.at-rule",
			},
			{
				foreground: "417e00",
				token: "meta.property-value",
			},
			{
				foreground: "b8860b",
				token: "constant.other.color",
			},
			{
				foreground: "ee3a8c",
				token: "keyword.other.important",
			},
			{
				foreground: "ee3a8c",
				token: "keyword.other.default",
			},
			{
				foreground: "417e00",
				token: "meta.property-value support.constant.named-color.css",
			},
			{
				foreground: "417e00",
				token: "meta.property-value constant",
			},
			{
				foreground: "417e00",
				token: "meta.constructor.argument.css",
			},
			{
				foreground: "9a5925",
				token: "constant.numeric",
			},
			{
				foreground: "9f5e3d",
				token: "keyword.other",
			},
			{
				foreground: "1b76b0",
				token: "source.scss support.function.misc",
			},
			{
				foreground: "f8bebe",
				background: "82000e",
				fontStyle: "italic",
				token: "meta.diff",
			},
			{
				foreground: "f8bebe",
				background: "82000e",
				fontStyle: "italic",
				token: "meta.diff.header",
			},
			{
				foreground: "f8f8f8",
				background: "420e09",
				token: "markup.deleted",
			},
			{
				foreground: "f8f8f8",
				background: "4a410d",
				token: "markup.changed",
			},
			{
				foreground: "f8f8f8",
				background: "253b22",
				token: "markup.inserted",
			},
			{
				foreground: "cd2626",
				fontStyle: "italic",
				token: "markup.italic",
			},
			{
				foreground: "8b1a1a",
				fontStyle: "bold",
				token: "markup.bold",
			},
			{
				foreground: "e18964",
				fontStyle: "underline",
				token: "markup.underline",
			},
			{
				foreground: "8b7765",
				background: "fee09c12",
				fontStyle: "italic",
				token: "markup.quote",
			},
			{
				foreground: "b8012d",
				background: "bf61330d",
				token: "markup.heading",
			},
			{
				foreground: "b8012d",
				background: "bf61330d",
				token: "markup.heading entity",
			},
			{
				foreground: "8f5b26",
				token: "markup.list",
			},
			{
				foreground: "578bb3",
				background: "b1b3ba08",
				token: "markup.raw",
			},
			{
				foreground: "f67b37",
				fontStyle: "italic",
				token: "markup comment",
			},
			{
				foreground: "60a633",
				background: "242424",
				token: "meta.separator",
			},
			{
				foreground: "578bb3",
				background: "b1b3ba08",
				token: "markup.other",
			},
			{
				background: "eeeeee29",
				token: "meta.line.entry.logfile",
			},
			{
				background: "eeeeee29",
				token: "meta.line.exit.logfile",
			},
			{
				background: "751012",
				token: "meta.line.error.logfile",
			},
			{
				background: "dcdcdc8f",
				token: "punctuation.definition.end",
			},
			{
				foreground: "629f9e",
				token: "entity.other.attribute-name.html",
			},
			{
				foreground: "79a316",
				token: "string.quoted.double.js",
			},
			{
				foreground: "79a316",
				token: "string.quoted.single.js",
			},
			{
				foreground: "488c45",
				fontStyle: "italic",
				token: "entity.name.function.js",
			},
			{
				foreground: "666666",
				token: "source.js.embedded.html",
			},
			{
				foreground: "bb3182",
				token: "storage.type.js",
			},
			{
				foreground: "338fd5",
				token: "support.class.js",
			},
			{
				foreground: "a99904",
				fontStyle: "italic",
				token: "keyword.control.js",
			},
			{
				foreground: "a99904",
				fontStyle: "italic",
				token: "keyword.operator.js",
			},
			{
				foreground: "616838",
				background: "d7d7a7",
				token: "entity.name.class",
			},
			{
				background: "968f96",
				token: "active_guide",
			},
			{
				background: "cbdc2f38",
				token: "highlight_matching_word",
			},
		],
		colors: {
			"editor.foreground": "#363636",
			"editor.background": "#E8E9E8",
			"editor.selectionBackground": "#F5AA0091",
			"editor.lineHighlightBackground": "#CBDC2F38",
			"editorCursor.foreground": "#202020",
			"editorWhitespace.foreground": "#0000004A",
			"editorIndentGuide.background": "#8F8F8F",
			"editorIndentGuide.activeBackground": "#FA2828",
		},
	},
	"Vibrant Ink": {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "000000",
				token: "",
			},
			{
				foreground: "ffffff",
				background: "0f0f0f",
				token: "text",
			},
			{
				background: "000000",
				token: "source.ruby.rails.embedded.html",
			},
			{
				foreground: "ffffff",
				background: "101010",
				token: "text.html.ruby",
			},
			{
				foreground: "ccff33",
				token: "constant.numeric.ruby",
			},
			{
				foreground: "ffffff",
				background: "000000",
				token: "source",
			},
			{
				foreground: "9933cc",
				token: "comment",
			},
			{
				foreground: "339999",
				token: "constant",
			},
			{
				foreground: "ff6600",
				token: "keyword",
			},
			{
				foreground: "edf8f9",
				token: "keyword.preprocessor",
			},
			{
				foreground: "ffffff",
				token: "keyword.preprocessor directive",
			},
			{
				foreground: "ffcc00",
				token: "entity.name.function",
			},
			{
				foreground: "ffcc00",
				token: "storage.type.function.js",
			},
			{
				fontStyle: "italic",
				token: "variable.parameter",
			},
			{
				foreground: "772cb7",
				background: "070707",
				token: "source comment.block",
			},
			{
				foreground: "ffffff",
				token: "variable.other",
			},
			{
				foreground: "999966",
				token: "support.function.activerecord.rails",
			},
			{
				foreground: "66ff00",
				token: "string",
			},
			{
				foreground: "aaaaaa",
				token: "string constant.character.escape",
			},
			{
				foreground: "000000",
				background: "cccc33",
				token: "string.interpolated",
			},
			{
				foreground: "44b4cc",
				token: "string.regexp",
			},
			{
				foreground: "cccc33",
				token: "string.literal",
			},
			{
				foreground: "555555",
				token: "string.interpolated constant.character.escape",
			},
			{
				fontStyle: "underline",
				token: "entity.name.class",
			},
			{
				fontStyle: "underline",
				token: "support.class.js",
			},
			{
				fontStyle: "italic underline",
				token: "entity.other.inherited-class",
			},
			{
				foreground: "ff6600",
				token: "meta.tag.inline.any.html",
			},
			{
				foreground: "ff6600",
				token: "meta.tag.block.any.html",
			},
			{
				foreground: "99cc99",
				fontStyle: "italic",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "dde93d",
				token: "keyword.other",
			},
			{
				foreground: "ff6600",
				token: "meta.selector.css",
			},
			{
				foreground: "ff6600",
				token: "entity.other.attribute-name.pseudo-class.css",
			},
			{
				foreground: "ff6600",
				token: "entity.name.tag.wildcard.css",
			},
			{
				foreground: "ff6600",
				token: "entity.other.attribute-name.id.css",
			},
			{
				foreground: "ff6600",
				token: "entity.other.attribute-name.class.css",
			},
			{
				foreground: "999966",
				token: "support.type.property-name.css",
			},
			{
				foreground: "ffffff",
				token: "keyword.other.unit.css",
			},
			{
				foreground: "ffffff",
				token: "constant.other.rgb-value.css",
			},
			{
				foreground: "ffffff",
				token: "constant.numeric.css",
			},
			{
				foreground: "ffffff",
				token: "support.function.event-handler.js",
			},
			{
				foreground: "ffffff",
				token: "keyword.operator.js",
			},
			{
				foreground: "cccc66",
				token: "keyword.control.js",
			},
			{
				foreground: "ffffff",
				token: "support.class.prototype.js",
			},
			{
				foreground: "ff6600",
				token: "object.property.function.prototype.js",
			},
		],
		colors: {
			"editor.foreground": "#FFFFFF",
			"editor.background": "#000000",
			"editor.selectionBackground": "#35493CE0",
			"editor.lineHighlightBackground": "#333300",
			"editorCursor.foreground": "#FFFFFF",
			"editorWhitespace.foreground": "#404040",
		},
	},
	Monokai: {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "272822",
				token: "",
			},
			{
				foreground: "75715e",
				token: "comment",
			},
			{
				foreground: "e6db74",
				token: "string",
			},
			{
				foreground: "ae81ff",
				token: "constant.numeric",
			},
			{
				foreground: "ae81ff",
				token: "constant.language",
			},
			{
				foreground: "ae81ff",
				token: "constant.character",
			},
			{
				foreground: "ae81ff",
				token: "constant.other",
			},
			{
				foreground: "f92672",
				token: "keyword",
			},
			{
				foreground: "f92672",
				token: "storage",
			},
			{
				foreground: "66d9ef",
				fontStyle: "italic",
				token: "storage.type",
			},
			{
				foreground: "a6e22e",
				fontStyle: "underline",
				token: "entity.name.class",
			},
			{
				foreground: "a6e22e",
				fontStyle: "italic underline",
				token: "entity.other.inherited-class",
			},
			{
				foreground: "a6e22e",
				token: "entity.name.function",
			},
			{
				foreground: "fd971f",
				fontStyle: "italic",
				token: "variable.parameter",
			},
			{
				foreground: "f92672",
				token: "entity.name.tag",
			},
			{
				foreground: "a6e22e",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "66d9ef",
				token: "support.function",
			},
			{
				foreground: "66d9ef",
				token: "support.constant",
			},
			{
				foreground: "66d9ef",
				fontStyle: "italic",
				token: "support.type",
			},
			{
				foreground: "66d9ef",
				fontStyle: "italic",
				token: "support.class",
			},
			{
				foreground: "f8f8f0",
				background: "f92672",
				token: "invalid",
			},
			{
				foreground: "f8f8f0",
				background: "ae81ff",
				token: "invalid.deprecated",
			},
			{
				foreground: "cfcfc2",
				token: "meta.structure.dictionary.json string.quoted.double.json",
			},
			{
				foreground: "75715e",
				token: "meta.diff",
			},
			{
				foreground: "75715e",
				token: "meta.diff.header",
			},
			{
				foreground: "f92672",
				token: "markup.deleted",
			},
			{
				foreground: "a6e22e",
				token: "markup.inserted",
			},
			{
				foreground: "e6db74",
				token: "markup.changed",
			},
			{
				foreground: "ae81ffa0",
				token: "constant.numeric.line-number.find-in-files - match",
			},
			{
				foreground: "e6db74",
				token: "entity.name.filename.find-in-files",
			},
		],
		colors: {
			"editor.foreground": "#F8F8F2",
			"editor.background": "#272822",
			"editor.selectionBackground": "#49483E",
			"editor.lineHighlightBackground": "#3E3D32",
			"editorCursor.foreground": "#F8F8F0",
			"editorWhitespace.foreground": "#3B3A32",
			"editorIndentGuide.activeBackground": "#9D550FB0",
			"editor.selectionHighlightBorder": "#222218",
		},
	},
	"Mono Industrial": {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "222C28",
				token: "",
			},
			{
				foreground: "666c68",
				background: "151c19",
				token: "comment",
			},
			{
				foreground: "c23b00",
				token: "storage",
			},
			{
				foreground: "c23b00",
				token: "support.type",
			},
			{
				foreground: "ffffff",
				background: "151c19",
				token: "string.unquoted.embedded",
			},
			{
				foreground: "ffffff",
				background: "151c19",
				token: "text source",
			},
			{
				foreground: "ffffff",
				background: "151c19",
				token: "string.unquoted",
			},
			{
				foreground: "e9470000",
				background: "1a0700",
				token: "constant.character.escaped",
			},
			{
				foreground: "e9470000",
				background: "1a0700",
				token: "string source - string.unquoted.embedded",
			},
			{
				foreground: "e9470000",
				background: "1a0700",
				token: "string string source",
			},
			{
				foreground: "c23800",
				background: "1a0700",
				token: "string - string source",
			},
			{
				foreground: "c23800",
				background: "1a0700",
				token: "string source string",
			},
			{
				foreground: "c23800",
				background: "1a0700",
				token: "meta.scope.heredoc",
			},
			{
				foreground: "e98800",
				token: "constant.numeric",
			},
			{
				foreground: "648bd2",
				token: "variable.language",
			},
			{
				foreground: "648bd2",
				token: "variable.other",
			},
			{
				foreground: "e98800",
				token: "constant",
			},
			{
				foreground: "a8b3ab",
				background: "161d1a",
				token: "other.preprocessor",
			},
			{
				foreground: "a8b3ab",
				background: "161d1a",
				token: "entity.name.preprocessor",
			},
			{
				foreground: "a8b3ab",
				token: "entity.name.function",
			},
			{
				foreground: "a8b3ab",
				token: "keyword.operator",
			},
			{
				foreground: "a8b3ab",
				token: "keyword.other.name-of-parameter",
			},
			{
				foreground: "9a2f00",
				token: "entity.name.class",
			},
			{
				foreground: "648bd2",
				token: "variable.parameter",
			},
			{
				foreground: "666c68",
				token: "storage.type.method",
			},
			{
				foreground: "a39e64",
				token: "keyword",
			},
			{
				foreground: "a39e64",
				token: "storage.type.function.php",
			},
			{
				foreground: "ffffff",
				background: "990000ad",
				token: "invalid",
			},
			{
				foreground: "000000",
				background: "ffd0d0",
				token: "invalid.trailing-whitespace",
			},
			{
				foreground: "588e60",
				token: "support.function",
			},
			{
				foreground: "5778b6",
				token: "support.class",
			},
			{
				foreground: "5778b6",
				token: "support.type",
			},
			{
				foreground: "5778b6",
				token: "entity.name",
			},
			{
				foreground: "c87500",
				token: "support.constant",
			},
			{
				foreground: "5879b7",
				token: "support.other.variable",
			},
			{
				foreground: "68685b",
				token: "declaration.xml-processing",
			},
			{
				foreground: "888888",
				token: "declaration.doctype",
			},
			{
				foreground: "888888",
				token: "declaration.doctype.DTD",
			},
			{
				foreground: "a65eff",
				token: "declaration.tag",
			},
			{
				foreground: "a65eff",
				token: "entity.name.tag",
			},
			{
				foreground: "909993",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "90999380",
				token: "punctuation",
			},
			{
				foreground: "7642b7",
				token: "entity.other.inherited-class",
			},
			{
				foreground: "ffffff",
				background: "00000059",
				token: "meta.scope.changed-files.svn",
			},
			{
				foreground: "ffffff",
				background: "00000059",
				token: "markup.inserted.svn",
			},
			{
				foreground: "ffffff",
				background: "00000059",
				token: "markup.changed.svn",
			},
			{
				foreground: "ffffff",
				background: "00000059",
				token: "markup.deleted.svn",
			},
			{
				background: "78807b0a",
				token: "meta.section",
			},
			{
				background: "78807b0a",
				token: "meta.section meta.section",
			},
			{
				background: "78807b0a",
				token: "meta.section meta.section meta.section",
			},
		],
		colors: {
			"editor.foreground": "#FFFFFF",
			"editor.background": "#222C28",
			"editor.selectionBackground": "#91999466",
			"editor.lineHighlightBackground": "#0C0D0C40",
			"editorCursor.foreground": "#FFFFFF",
			"editorWhitespace.foreground": "#666C6880",
		},
	},
	"Birds of Paradise": {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "372725",
				token: "",
			},
			{
				foreground: "e6e1c4",
				background: "322323",
				token: "source",
			},
			{
				foreground: "6b4e32",
				fontStyle: "italic",
				token: "comment",
			},
			{
				foreground: "ef5d32",
				token: "keyword",
			},
			{
				foreground: "ef5d32",
				token: "storage",
			},
			{
				foreground: "efac32",
				token: "entity.name.function",
			},
			{
				foreground: "efac32",
				token: "keyword.other.name-of-parameter.objc",
			},
			{
				foreground: "efac32",
				fontStyle: "bold",
				token: "entity.name",
			},
			{
				foreground: "6c99bb",
				token: "constant.numeric",
			},
			{
				foreground: "7daf9c",
				token: "variable.language",
			},
			{
				foreground: "7daf9c",
				token: "variable.other",
			},
			{
				foreground: "6c99bb",
				token: "constant",
			},
			{
				foreground: "efac32",
				token: "variable.other.constant",
			},
			{
				foreground: "6c99bb",
				token: "constant.language",
			},
			{
				foreground: "d9d762",
				token: "string",
			},
			{
				foreground: "efac32",
				token: "support.function",
			},
			{
				foreground: "efac32",
				token: "support.type",
			},
			{
				foreground: "6c99bb",
				token: "support.constant",
			},
			{
				foreground: "efcb43",
				token: "meta.tag",
			},
			{
				foreground: "efcb43",
				token: "declaration.tag",
			},
			{
				foreground: "efcb43",
				token: "entity.name.tag",
			},
			{
				foreground: "efcb43",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "ffffff",
				background: "990000",
				token: "invalid",
			},
			{
				foreground: "7daf9c",
				token: "constant.character.escaped",
			},
			{
				foreground: "7daf9c",
				token: "constant.character.escape",
			},
			{
				foreground: "7daf9c",
				token: "string source",
			},
			{
				foreground: "7daf9c",
				token: "string source.ruby",
			},
			{
				foreground: "e6e1dc",
				background: "144212",
				token: "markup.inserted",
			},
			{
				foreground: "e6e1dc",
				background: "660000",
				token: "markup.deleted",
			},
			{
				background: "2f33ab",
				token: "meta.diff.header",
			},
			{
				background: "2f33ab",
				token: "meta.separator.diff",
			},
			{
				background: "2f33ab",
				token: "meta.diff.index",
			},
			{
				background: "2f33ab",
				token: "meta.diff.range",
			},
		],
		colors: {
			"editor.foreground": "#E6E1C4",
			"editor.background": "#372725",
			"editor.selectionBackground": "#16120E",
			"editor.lineHighlightBackground": "#1F1611",
			"editorCursor.foreground": "#E6E1C4",
			"editorWhitespace.foreground": "#42302D",
		},
	},
	Eiffel: {
		base: "vs",
		inherit: true,
		rules: [
			{
				background: "FFFFFF",
				token: "",
			},
			{
				foreground: "00b418",
				token: "comment",
			},
			{
				foreground: "0206ff",
				fontStyle: "italic",
				token: "variable",
			},
			{
				foreground: "0100b6",
				fontStyle: "bold",
				token: "keyword",
			},
			{
				foreground: "cd0000",
				fontStyle: "italic",
				token: "constant.numeric",
			},
			{
				foreground: "c5060b",
				fontStyle: "italic",
				token: "constant",
			},
			{
				foreground: "585cf6",
				fontStyle: "italic",
				token: "constant.language",
			},
			{
				foreground: "d80800",
				token: "string",
			},
			{
				foreground: "26b31a",
				token: "constant.character.escape",
			},
			{
				foreground: "26b31a",
				token: "string source",
			},
			{
				foreground: "1a921c",
				token: "meta.preprocessor",
			},
			{
				foreground: "0c450d",
				fontStyle: "bold",
				token: "keyword.control.import",
			},
			{
				foreground: "0000a2",
				fontStyle: "bold",
				token: "entity.name.function",
			},
			{
				foreground: "0000a2",
				fontStyle: "bold",
				token: "keyword.other.name-of-parameter.objc",
			},
			{
				fontStyle: "italic",
				token: "entity.name.type",
			},
			{
				fontStyle: "italic",
				token: "entity.other.inherited-class",
			},
			{
				fontStyle: "italic",
				token: "variable.parameter",
			},
			{
				foreground: "70727e",
				token: "storage.type.method",
			},
			{
				fontStyle: "italic",
				token: "meta.section entity.name.section",
			},
			{
				fontStyle: "italic",
				token: "declaration.section entity.name.section",
			},
			{
				foreground: "3c4c72",
				fontStyle: "bold",
				token: "support.function",
			},
			{
				foreground: "6d79de",
				fontStyle: "bold",
				token: "support.class",
			},
			{
				foreground: "6d79de",
				fontStyle: "bold",
				token: "support.type",
			},
			{
				foreground: "06960e",
				fontStyle: "bold",
				token: "support.constant",
			},
			{
				foreground: "21439c",
				fontStyle: "bold",
				token: "support.variable",
			},
			{
				foreground: "687687",
				token: "keyword.operator.js",
			},
			{
				foreground: "ffffff",
				background: "990000",
				token: "invalid",
			},
			{
				background: "ffd0d0",
				token: "invalid.deprecated.trailing-whitespace",
			},
			{
				background: "427ff530",
				token: "text source",
			},
			{
				background: "427ff530",
				token: "string.unquoted",
			},
			{
				foreground: "68685b",
				token: "meta.xml-processing",
			},
			{
				foreground: "68685b",
				token: "declaration.xml-processing",
			},
			{
				foreground: "888888",
				token: "meta.doctype",
			},
			{
				foreground: "888888",
				token: "declaration.doctype",
			},
			{
				fontStyle: "italic",
				token: "meta.doctype.DTD",
			},
			{
				fontStyle: "italic",
				token: "declaration.doctype.DTD",
			},
			{
				foreground: "1c02ff",
				token: "meta.tag",
			},
			{
				foreground: "1c02ff",
				token: "declaration.tag",
			},
			{
				fontStyle: "bold",
				token: "entity.name.tag",
			},
			{
				fontStyle: "italic",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "0c07ff",
				fontStyle: "bold",
				token: "markup.heading",
			},
			{
				foreground: "000000",
				fontStyle: "italic",
				token: "markup.quote",
			},
			{
				foreground: "b90690",
				token: "markup.list",
			},
		],
		colors: {
			"editor.foreground": "#000000",
			"editor.background": "#FFFFFF",
			"editor.selectionBackground": "#C3DCFF",
			"editor.lineHighlightBackground": "#00000012",
			"editorCursor.foreground": "#000000",
			"editorWhitespace.foreground": "#BFBFBF",
		},
	},
	"Solarized Light": {
		base: "vs",
		inherit: true,
		rules: [
			{
				background: "FDF6E3",
				token: "",
			},
			{
				foreground: "93a1a1",
				token: "comment",
			},
			{
				foreground: "2aa198",
				token: "string",
			},
			{
				foreground: "586e75",
				token: "string",
			},
			{
				foreground: "dc322f",
				token: "string.regexp",
			},
			{
				foreground: "d33682",
				token: "constant.numeric",
			},
			{
				foreground: "268bd2",
				token: "variable.language",
			},
			{
				foreground: "268bd2",
				token: "variable.other",
			},
			{
				foreground: "859900",
				token: "keyword",
			},
			{
				foreground: "073642",
				fontStyle: "bold",
				token: "storage",
			},
			{
				foreground: "268bd2",
				token: "entity.name.class",
			},
			{
				foreground: "268bd2",
				token: "entity.name.type.class",
			},
			{
				foreground: "268bd2",
				token: "entity.name.function",
			},
			{
				foreground: "859900",
				token: "punctuation.definition.variable",
			},
			{
				foreground: "dc322f",
				token: "punctuation.section.embedded.begin",
			},
			{
				foreground: "dc322f",
				token: "punctuation.section.embedded.end",
			},
			{
				foreground: "b58900",
				token: "constant.language",
			},
			{
				foreground: "b58900",
				token: "meta.preprocessor",
			},
			{
				foreground: "dc322f",
				token: "support.function.construct",
			},
			{
				foreground: "dc322f",
				token: "keyword.other.new",
			},
			{
				foreground: "cb4b16",
				token: "constant.character",
			},
			{
				foreground: "cb4b16",
				token: "constant.other",
			},
			{
				foreground: "268bd2",
				fontStyle: "bold",
				token: "entity.name.tag",
			},
			{
				foreground: "93a1a1",
				token: "punctuation.definition.tag.html",
			},
			{
				foreground: "93a1a1",
				token: "punctuation.definition.tag.begin",
			},
			{
				foreground: "93a1a1",
				token: "punctuation.definition.tag.end",
			},
			{
				foreground: "93a1a1",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "268bd2",
				token: "support.function",
			},
			{
				foreground: "dc322f",
				token: "punctuation.separator.continuation",
			},
			{
				foreground: "859900",
				token: "support.type",
			},
			{
				foreground: "859900",
				token: "support.class",
			},
			{
				foreground: "cb4b16",
				token: "support.type.exception",
			},
			{
				foreground: "cb4b16",
				token: "keyword.other.special-method",
			},
			{
				foreground: "2aa198",
				token: "string.quoted.double",
			},
			{
				foreground: "2aa198",
				token: "string.quoted.single",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.begin",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.end",
			},
			{
				foreground: "b58900",
				token: "entity.name.tag.css",
			},
			{
				foreground: "b58900",
				token: "support.type.property-name.css",
			},
			{
				foreground: "b58900",
				token: "meta.property-name.css",
			},
			{
				foreground: "dc322f",
				token: "source.css",
			},
			{
				foreground: "586e75",
				token: "meta.selector.css",
			},
			{
				foreground: "6c71c4",
				token: "punctuation.section.property-list.css",
			},
			{
				foreground: "2aa198",
				token: "meta.property-value.css constant.numeric.css",
			},
			{
				foreground: "2aa198",
				token: "keyword.other.unit.css",
			},
			{
				foreground: "2aa198",
				token: "constant.other.color.rgb-value.css",
			},
			{
				foreground: "2aa198",
				token: "meta.property-value.css",
			},
			{
				foreground: "dc322f",
				token: "keyword.other.important.css",
			},
			{
				foreground: "2aa198",
				token: "support.constant.color",
			},
			{
				foreground: "859900",
				token: "entity.name.tag.css",
			},
			{
				foreground: "586e75",
				token: "punctuation.separator.key-value.css",
			},
			{
				foreground: "586e75",
				token: "punctuation.terminator.rule.css",
			},
			{
				foreground: "268bd2",
				token: "entity.other.attribute-name.class.css",
			},
			{
				foreground: "cb4b16",
				token: "entity.other.attribute-name.pseudo-element.css",
			},
			{
				foreground: "cb4b16",
				token: "entity.other.attribute-name.pseudo-class.css",
			},
			{
				foreground: "268bd2",
				token: "entity.other.attribute-name.id.css",
			},
			{
				foreground: "b58900",
				token: "meta.function.js",
			},
			{
				foreground: "b58900",
				token: "entity.name.function.js",
			},
			{
				foreground: "b58900",
				token: "support.function.dom.js",
			},
			{
				foreground: "b58900",
				token: "text.html.basic source.js.embedded.html",
			},
			{
				foreground: "268bd2",
				token: "storage.type.function.js",
			},
			{
				foreground: "2aa198",
				token: "constant.numeric.js",
			},
			{
				foreground: "268bd2",
				token: "meta.brace.square.js",
			},
			{
				foreground: "268bd2",
				token: "storage.type.js",
			},
			{
				foreground: "93a1a1",
				token: "meta.brace.round",
			},
			{
				foreground: "93a1a1",
				token: "punctuation.definition.parameters.begin.js",
			},
			{
				foreground: "93a1a1",
				token: "punctuation.definition.parameters.end.js",
			},
			{
				foreground: "268bd2",
				token: "meta.brace.curly.js",
			},
			{
				foreground: "93a1a1",
				fontStyle: "italic",
				token: "entity.name.tag.doctype.html",
			},
			{
				foreground: "93a1a1",
				fontStyle: "italic",
				token: "meta.tag.sgml.html",
			},
			{
				foreground: "93a1a1",
				fontStyle: "italic",
				token: "string.quoted.double.doctype.identifiers-and-DTDs.html",
			},
			{
				foreground: "839496",
				fontStyle: "italic",
				token: "comment.block.html",
			},
			{
				fontStyle: "italic",
				token: "entity.name.tag.script.html",
			},
			{
				foreground: "2aa198",
				token: "source.css.embedded.html string.quoted.double.html",
			},
			{
				foreground: "cb4b16",
				fontStyle: "bold",
				token: "text.html.ruby",
			},
			{
				foreground: "657b83",
				token: "text.html.basic meta.tag.other.html",
			},
			{
				foreground: "657b83",
				token: "text.html.basic meta.tag.any.html",
			},
			{
				foreground: "657b83",
				token: "text.html.basic meta.tag.block.any",
			},
			{
				foreground: "657b83",
				token: "text.html.basic meta.tag.inline.any",
			},
			{
				foreground: "657b83",
				token: "text.html.basic meta.tag.structure.any.html",
			},
			{
				foreground: "657b83",
				token: "text.html.basic source.js.embedded.html",
			},
			{
				foreground: "657b83",
				token: "punctuation.separator.key-value.html",
			},
			{
				foreground: "657b83",
				token: "text.html.basic entity.other.attribute-name.html",
			},
			{
				foreground: "2aa198",
				token: "text.html.basic meta.tag.structure.any.html punctuation.definition.string.begin.html",
			},
			{
				foreground: "2aa198",
				token: "punctuation.definition.string.begin.html",
			},
			{
				foreground: "2aa198",
				token: "punctuation.definition.string.end.html",
			},
			{
				foreground: "268bd2",
				fontStyle: "bold",
				token: "entity.name.tag.block.any.html",
			},
			{
				fontStyle: "italic",
				token: "source.css.embedded.html entity.name.tag.style.html",
			},
			{
				foreground: "839496",
				fontStyle: "italic",
				token: "source.css.embedded.html",
			},
			{
				foreground: "839496",
				fontStyle: "italic",
				token: "comment.block.html",
			},
			{
				foreground: "268bd2",
				token: "punctuation.definition.variable.ruby",
			},
			{
				foreground: "657b83",
				token: "meta.function.method.with-arguments.ruby",
			},
			{
				foreground: "2aa198",
				token: "variable.language.ruby",
			},
			{
				foreground: "268bd2",
				token: "entity.name.function.ruby",
			},
			{
				foreground: "859900",
				fontStyle: "bold",
				token: "keyword.control.ruby",
			},
			{
				foreground: "859900",
				fontStyle: "bold",
				token: "keyword.control.def.ruby",
			},
			{
				foreground: "859900",
				token: "keyword.control.class.ruby",
			},
			{
				foreground: "859900",
				token: "meta.class.ruby",
			},
			{
				foreground: "b58900",
				token: "entity.name.type.class.ruby",
			},
			{
				foreground: "859900",
				token: "keyword.control.ruby",
			},
			{
				foreground: "b58900",
				token: "support.class.ruby",
			},
			{
				foreground: "859900",
				token: "keyword.other.special-method.ruby",
			},
			{
				foreground: "2aa198",
				token: "constant.language.ruby",
			},
			{
				foreground: "2aa198",
				token: "constant.numeric.ruby",
			},
			{
				foreground: "b58900",
				token: "variable.other.constant.ruby",
			},
			{
				foreground: "2aa198",
				token: "constant.other.symbol.ruby",
			},
			{
				foreground: "dc322f",
				token: "punctuation.section.embedded.ruby",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.begin.ruby",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.end.ruby",
			},
			{
				foreground: "cb4b16",
				token: "keyword.other.special-method.ruby",
			},
			{
				foreground: "cb4b16",
				token: "keyword.control.import.include.php",
			},
			{
				foreground: "839496",
				token: "text.html.ruby meta.tag.inline.any.html",
			},
			{
				foreground: "2aa198",
				token: "text.html.ruby punctuation.definition.string.begin",
			},
			{
				foreground: "2aa198",
				token: "text.html.ruby punctuation.definition.string.end",
			},
			{
				foreground: "839496",
				token: "punctuation.definition.string.begin",
			},
			{
				foreground: "839496",
				token: "punctuation.definition.string.end",
			},
			{
				foreground: "dc322f",
				token: "keyword.operator.index-start.php",
			},
			{
				foreground: "dc322f",
				token: "keyword.operator.index-end.php",
			},
			{
				foreground: "586e75",
				token: "meta.array.php",
			},
			{
				foreground: "b58900",
				token: "meta.array.php support.function.construct.php",
			},
			{
				foreground: "b58900",
				token: "meta.array.empty.php support.function.construct.php",
			},
			{
				foreground: "b58900",
				token: "support.function.construct.php",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.array.begin",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.array.end",
			},
			{
				foreground: "2aa198",
				token: "constant.numeric.php",
			},
			{
				foreground: "cb4b16",
				token: "keyword.other.new.php",
			},
			{
				foreground: "586e75",
				token: "support.class.php",
			},
			{
				foreground: "586e75",
				token: "keyword.operator.class",
			},
			{
				foreground: "93a1a1",
				token: "variable.other.property.php",
			},
			{
				foreground: "b58900",
				token: "storage.modifier.extends.php",
			},
			{
				foreground: "b58900",
				token: "storage.type.class.php",
			},
			{
				foreground: "b58900",
				token: "keyword.operator.class.php",
			},
			{
				foreground: "586e75",
				token: "meta.other.inherited-class.php",
			},
			{
				foreground: "859900",
				token: "storage.type.php",
			},
			{
				foreground: "93a1a1",
				token: "entity.name.function.php",
			},
			{
				foreground: "859900",
				token: "support.function.construct.php",
			},
			{
				foreground: "839496",
				token: "entity.name.type.class.php",
			},
			{
				foreground: "839496",
				token: "meta.function-call.php",
			},
			{
				foreground: "839496",
				token: "meta.function-call.static.php",
			},
			{
				foreground: "839496",
				token: "meta.function-call.object.php",
			},
			{
				foreground: "93a1a1",
				token: "keyword.other.phpdoc",
			},
			{
				foreground: "cb4b16",
				token: "source.php.embedded.block.html",
			},
			{
				foreground: "cb4b16",
				token: "storage.type.function.php",
			},
			{
				foreground: "2aa198",
				token: "constant.numeric.c",
			},
			{
				foreground: "cb4b16",
				token: "meta.preprocessor.c.include",
			},
			{
				foreground: "cb4b16",
				token: "meta.preprocessor.macro.c",
			},
			{
				foreground: "cb4b16",
				token: "keyword.control.import.define.c",
			},
			{
				foreground: "cb4b16",
				token: "keyword.control.import.include.c",
			},
			{
				foreground: "cb4b16",
				token: "entity.name.function.preprocessor.c",
			},
			{
				foreground: "2aa198",
				token: "meta.preprocessor.c.include string.quoted.other.lt-gt.include.c",
			},
			{
				foreground: "2aa198",
				token: "meta.preprocessor.c.include punctuation.definition.string.begin.c",
			},
			{
				foreground: "2aa198",
				token: "meta.preprocessor.c.include punctuation.definition.string.end.c",
			},
			{
				foreground: "586e75",
				token: "support.function.C99.c",
			},
			{
				foreground: "586e75",
				token: "support.function.any-method.c",
			},
			{
				foreground: "586e75",
				token: "entity.name.function.c",
			},
			{
				foreground: "2aa198",
				token: "punctuation.definition.string.begin.c",
			},
			{
				foreground: "2aa198",
				token: "punctuation.definition.string.end.c",
			},
			{
				foreground: "b58900",
				token: "storage.type.c",
			},
			{
				foreground: "e0eddd",
				background: "b58900",
				fontStyle: "italic",
				token: "meta.diff",
			},
			{
				foreground: "e0eddd",
				background: "b58900",
				fontStyle: "italic",
				token: "meta.diff.header",
			},
			{
				foreground: "dc322f",
				background: "eee8d5",
				token: "markup.deleted",
			},
			{
				foreground: "cb4b16",
				background: "eee8d5",
				token: "markup.changed",
			},
			{
				foreground: "219186",
				background: "eee8d5",
				token: "markup.inserted",
			},
			{
				foreground: "e0eddd",
				background: "a57706",
				token: "text.html.markdown meta.dummy.line-break",
			},
			{
				foreground: "2aa198",
				token: "text.html.markdown markup.raw.inline",
			},
			{
				foreground: "2aa198",
				token: "text.restructuredtext markup.raw",
			},
			{
				foreground: "dc322f",
				token: "other.package.exclude",
			},
			{
				foreground: "dc322f",
				token: "other.remove",
			},
			{
				foreground: "2aa198",
				token: "other.add",
			},
			{
				foreground: "dc322f",
				token: "punctuation.section.group.tex",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.arguments.begin.latex",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.arguments.end.latex",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.arguments.latex",
			},
			{
				foreground: "b58900",
				token: "meta.group.braces.tex",
			},
			{
				foreground: "b58900",
				token: "string.other.math.tex",
			},
			{
				foreground: "cb4b16",
				token: "variable.parameter.function.latex",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.constant.math.tex",
			},
			{
				foreground: "2aa198",
				token: "text.tex.latex constant.other.math.tex",
			},
			{
				foreground: "2aa198",
				token: "constant.other.general.math.tex",
			},
			{
				foreground: "2aa198",
				token: "constant.other.general.math.tex",
			},
			{
				foreground: "2aa198",
				token: "constant.character.math.tex",
			},
			{
				foreground: "b58900",
				token: "string.other.math.tex",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.begin.tex",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.end.tex",
			},
			{
				foreground: "2aa198",
				token: "keyword.control.label.latex",
			},
			{
				foreground: "2aa198",
				token: "text.tex.latex constant.other.general.math.tex",
			},
			{
				foreground: "dc322f",
				token: "variable.parameter.definition.label.latex",
			},
			{
				foreground: "859900",
				token: "support.function.be.latex",
			},
			{
				foreground: "cb4b16",
				token: "support.function.section.latex",
			},
			{
				foreground: "2aa198",
				token: "support.function.general.tex",
			},
			{
				fontStyle: "italic",
				token: "punctuation.definition.comment.tex",
			},
			{
				fontStyle: "italic",
				token: "comment.line.percentage.tex",
			},
			{
				foreground: "2aa198",
				token: "keyword.control.ref.latex",
			},
			{
				foreground: "586e75",
				token: "string.quoted.double.block.python",
			},
			{
				foreground: "859900",
				token: "storage.type.class.python",
			},
			{
				foreground: "859900",
				token: "storage.type.function.python",
			},
			{
				foreground: "859900",
				token: "storage.modifier.global.python",
			},
			{
				foreground: "cb4b16",
				token: "keyword.control.import.python",
			},
			{
				foreground: "cb4b16",
				token: "keyword.control.import.from.python",
			},
			{
				foreground: "b58900",
				token: "support.type.exception.python",
			},
			{
				foreground: "859900",
				token: "support.function.builtin.shell",
			},
			{
				foreground: "cb4b16",
				token: "variable.other.normal.shell",
			},
			{
				foreground: "268bd2",
				token: "source.shell",
			},
			{
				foreground: "586e75",
				token: "meta.scope.for-in-loop.shell",
			},
			{
				foreground: "586e75",
				token: "variable.other.loop.shell",
			},
			{
				foreground: "859900",
				token: "punctuation.definition.string.end.shell",
			},
			{
				foreground: "859900",
				token: "punctuation.definition.string.begin.shell",
			},
			{
				foreground: "586e75",
				token: "meta.scope.case-block.shell",
			},
			{
				foreground: "586e75",
				token: "meta.scope.case-body.shell",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.logical-expression.shell",
			},
			{
				fontStyle: "italic",
				token: "comment.line.number-sign.shell",
			},
			{
				foreground: "cb4b16",
				token: "keyword.other.import.java",
			},
			{
				foreground: "586e75",
				token: "storage.modifier.import.java",
			},
			{
				foreground: "b58900",
				token: "meta.class.java storage.modifier.java",
			},
			{
				foreground: "586e75",
				token: "source.java comment.block",
			},
			{
				foreground: "586e75",
				token: "comment.block meta.documentation.tag.param.javadoc keyword.other.documentation.param.javadoc",
			},
			{
				foreground: "b58900",
				token: "punctuation.definition.variable.perl",
			},
			{
				foreground: "b58900",
				token: "variable.other.readwrite.global.perl",
			},
			{
				foreground: "b58900",
				token: "variable.other.predefined.perl",
			},
			{
				foreground: "b58900",
				token: "keyword.operator.comparison.perl",
			},
			{
				foreground: "859900",
				token: "support.function.perl",
			},
			{
				foreground: "586e75",
				fontStyle: "italic",
				token: "comment.line.number-sign.perl",
			},
			{
				foreground: "2aa198",
				token: "punctuation.definition.string.begin.perl",
			},
			{
				foreground: "2aa198",
				token: "punctuation.definition.string.end.perl",
			},
			{
				foreground: "dc322f",
				token: "constant.character.escape.perl",
			},
			{
				foreground: "268bd2",
				token: "markup.heading.markdown",
			},
			{
				foreground: "268bd2",
				token: "markup.heading.1.markdown",
			},
			{
				foreground: "268bd2",
				token: "markup.heading.2.markdown",
			},
			{
				foreground: "268bd2",
				token: "markup.heading.3.markdown",
			},
			{
				foreground: "268bd2",
				token: "markup.heading.4.markdown",
			},
			{
				foreground: "268bd2",
				token: "markup.heading.5.markdown",
			},
			{
				foreground: "268bd2",
				token: "markup.heading.6.markdown",
			},
			{
				foreground: "586e75",
				fontStyle: "bold",
				token: "markup.bold.markdown",
			},
			{
				foreground: "586e75",
				fontStyle: "italic",
				token: "markup.italic.markdown",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.bold.markdown",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.italic.markdown",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.raw.markdown",
			},
			{
				foreground: "b58900",
				token: "markup.list.unnumbered.markdown",
			},
			{
				foreground: "859900",
				token: "markup.list.numbered.markdown",
			},
			{
				foreground: "2aa198",
				token: "markup.raw.block.markdown",
			},
			{
				foreground: "2aa198",
				token: "markup.raw.inline.markdown",
			},
			{
				foreground: "6c71c4",
				token: "markup.quote.markdown",
			},
			{
				foreground: "6c71c4",
				token: "punctuation.definition.blockquote.markdown",
			},
			{
				foreground: "d33682",
				token: "meta.separator.markdown",
			},
			{
				foreground: "839496",
				token: "markup.underline.link.markdown",
			},
			{
				foreground: "839496",
				token: "markup.underline.link.markdown",
			},
			{
				foreground: "dc322f",
				token: "meta.link.inet.markdown",
			},
			{
				foreground: "dc322f",
				token: "meta.link.email.lt-gt.markdown",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.begin.markdown",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.string.end.markdown",
			},
			{
				foreground: "dc322f",
				token: "punctuation.definition.link.markdown",
			},
			{
				foreground: "6a8187",
				token: "text.plain",
			},
			{
				foreground: "eee8d5",
				background: "eee8d5",
				token: "sublimelinter.notes",
			},
			{
				foreground: "93a1a1",
				background: "93a1a1",
				token: "sublimelinter.outline.illegal",
			},
			{
				background: "dc322f",
				token: "sublimelinter.underline.illegal",
			},
			{
				foreground: "839496",
				background: "839496",
				token: "sublimelinter.outline.warning",
			},
			{
				background: "b58900",
				token: "sublimelinter.underline.warning",
			},
			{
				foreground: "657b83",
				background: "657b83",
				token: "sublimelinter.outline.violation",
			},
			{
				background: "cb4b16",
				token: "sublimelinter.underline.violation",
			},
		],
		colors: {
			"editor.foreground": "#586E75",
			"editor.background": "#FDF6E3",
			"editor.selectionBackground": "#EEE8D5",
			"editor.lineHighlightBackground": "#EEE8D5",
			"editorCursor.foreground": "#000000",
			"editorWhitespace.foreground": "#EAE3C9",
		},
	},
	"All Hallows Eve": {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "000000",
				token: "",
			},
			{
				foreground: "ffffff",
				background: "434242",
				token: "text",
			},
			{
				foreground: "ffffff",
				background: "000000",
				token: "source",
			},
			{
				foreground: "9933cc",
				token: "comment",
			},
			{
				foreground: "3387cc",
				token: "constant",
			},
			{
				foreground: "cc7833",
				token: "keyword",
			},
			{
				foreground: "d0d0ff",
				token: "meta.preprocessor.c",
			},
			{
				fontStyle: "italic",
				token: "variable.parameter",
			},
			{
				foreground: "ffffff",
				background: "9b9b9b",
				token: "source comment.block",
			},
			{
				foreground: "66cc33",
				token: "string",
			},
			{
				foreground: "aaaaaa",
				token: "string constant.character.escape",
			},
			{
				foreground: "000000",
				background: "cccc33",
				token: "string.interpolated",
			},
			{
				foreground: "cccc33",
				token: "string.regexp",
			},
			{
				foreground: "cccc33",
				token: "string.literal",
			},
			{
				foreground: "555555",
				token: "string.interpolated constant.character.escape",
			},
			{
				fontStyle: "underline",
				token: "entity.name.type",
			},
			{
				fontStyle: "italic underline",
				token: "entity.other.inherited-class",
			},
			{
				fontStyle: "underline",
				token: "entity.name.tag",
			},
			{
				foreground: "c83730",
				token: "support.function",
			},
		],
		colors: {
			"editor.foreground": "#FFFFFF",
			"editor.background": "#000000",
			"editor.selectionBackground": "#73597EE0",
			"editor.lineHighlightBackground": "#333300",
			"editorCursor.foreground": "#FFFFFF",
			"editorWhitespace.foreground": "#404040",
		},
	},
	Matrix: {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "0D0D0D",
				token: "",
			},
			{
				foreground: "00FF00",
				background: "131313",
				token: "text",
			},
			{
				foreground: "00FF00",
				background: "0D0D0D",
				token: "source",
			},
			{
				foreground: "008800",
				token: "comment",
			},
			{
				foreground: "33FF33",
				token: "constant",
			},
			{
				foreground: "00CC00",
				token: "keyword",
			},
			{
				foreground: "55FF55",
				token: "meta.preprocessor.c",
			},
			{
				fontStyle: "italic",
				foreground: "22FF22",
				token: "variable.parameter",
			},
			{
				foreground: "00FF00",
				background: "003300",
				token: "source comment.block",
			},
			{
				foreground: "44FF44",
				token: "string",
			},
			{
				foreground: "88FF88",
				token: "string constant.character.escape",
			},
			{
				foreground: "000000",
				background: "00AA00",
				token: "string.interpolated",
			},
			{
				foreground: "77FF77",
				token: "string.regexp",
			},
			{
				foreground: "77FF77",
				token: "string.literal",
			},
			{
				foreground: "005500",
				token: "string.interpolated constant.character.escape",
			},
			{
				fontStyle: "underline",
				foreground: "00DD00",
				token: "entity.name.type",
			},
			{
				fontStyle: "italic underline",
				foreground: "00BB00",
				token: "entity.other.inherited-class",
			},
			{
				fontStyle: "underline",
				foreground: "00FF00",
				token: "entity.name.tag",
			},
			{
				foreground: "00FF33",
				token: "support.function",
			},
		],
		colors: {
			"editor.foreground": "#00FF00",
			"editor.background": "#0D0D0D",
			"editor.selectionBackground": "#003300",
			"editor.lineHighlightBackground": "#002200",
			"editorCursor.foreground": "#00FF00",
			"editorWhitespace.foreground": "#003300",
			"editor.findMatchBackground": "#00FF0044",
			"editor.findMatchHighlightBackground": "#00AA0044",
		},
	},
	Cyberpunk: {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "0d0e14",
				token: "",
			},
			{
				foreground: "ff00ff",
				token: "comment",
			},
			{
				foreground: "00ffff",
				token: "constant",
			},
			{
				foreground: "f92aad",
				token: "keyword",
			},
			{
				foreground: "01cdfe",
				token: "storage",
			},
			{
				foreground: "0aefff",
				token: "entity.name.function",
			},
			{
				foreground: "96f2ef",
				token: "support.function",
			},
			{
				foreground: "f97e72",
				token: "string",
			},
			{
				foreground: "36f9f6",
				token: "variable",
			},
			{
				foreground: "ff7edb",
				token: "entity.name.tag",
			},
			{
				foreground: "fede5d",
				token: "entity.other.attribute-name",
			},
			{
				foreground: "72f1b8",
				token: "entity.name.type",
			},
			{
				foreground: "ff8b39",
				token: "entity.other.inherited-class",
			},
		],
		colors: {
			"editor.foreground": "#f8f8f2",
			"editor.background": "#0d0e14",
			"editor.selectionBackground": "#ff007722",
			"editor.lineHighlightBackground": "#192333",
			"editorCursor.foreground": "#f8f8f0",
			"editorWhitespace.foreground": "#3b3a32",
			"editorIndentGuide.background": "#3b3a3266",
			"editorIndentGuide.activeBackground": "#9d550fb0",
		},
	},
	"Notitia Designer": {
		base: "vs-dark",
		inherit: true,
		rules: [
			{
				background: "1e1e1e",
				token: "",
			},
			{
				foreground: "e8e8e8",
				token: "text",
			},
			{
				foreground: "ffe066",
				token: "keyword",
			},
			{
				foreground: "ffeb3b",
				token: "string",
			},
			{
				foreground: "ffd700",
				token: "variable",
			},
			{
				foreground: "ffc107",
				token: "comment",
			},
			{
				foreground: "fff176",
				token: "number",
			},
			{
				foreground: "ffecb3",
				token: "function",
			},
			{
				fontStyle: "italic",
				token: "variable.parameter",
			},
			{
				fontStyle: "underline",
				token: "entity.name.type",
			},
			{
				foreground: "f9a825",
				token: "meta",
			},
		],
		colors: {
			"editor.foreground": "#e8e8e8",
			"editor.background": "#1e1e1e",
			"editor.selectionBackground": "#503e2e",
			"editor.lineHighlightBackground": "#333300",
			"editorCursor.foreground": "#ffeb3b",
			"editorWhitespace.foreground": "#404040",
		},
	},
};
